<template lang="html">
  <div class="" id="cotizacion">
    <div class="row w-full" v-if="email == ''">
      <div class="vx-col w-full md:w-3/3 sm:w-2/2 ">
        <vx-card class="text-center cursor-pointer">
          <img src="@/assets/images/pages/graphic-2.png" alt="graphic" width="180" class="mx-auto mb-4">
          <h4 class="mb-2">Añade un coacreditado</h4>
          <small>Regresa al apartado solicitante para agregar un coacreditado</small>
        </vx-card>
      </div>
    </div>
    <div class="row w-full" v-else>

      <vs-row vs-type="flex" vs-justify="flex-end">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="12">
          <vs-button color="danger"  @click="eliminarCoacreditado()">Eliminar Coacreditado</vs-button>
        </vs-col>
      </vs-row>

      <div class="vx-col w-full">

        <div class="row w-full -mb-4">
          <div class="col-md-12">
            <h5 class="font-bold">Datos personales</h5> 
          </div>
			  </div>

        <div class="row w-full">
          <div class="vx-col lg:w-1/3 sm:w-full">
            <span class="span-placeholder">Correo cliente * </span>
            <input class="vs-input" label="Nombre(s)" v-model="email" name="username" disabled/>
          </div>
          <div class="col-md-4">
            <span class="span-placeholder">CURP *</span>
            <input class="vs-input" label="Curp" v-model="curp" name="username" />
          </div>
          <div class="col-md-4">
            <span class="span-placeholder">RFC *</span>
            <input class="vs-input" label="RFC" v-model="rfc" name="username" />
          </div>
        </div>
        <div class="row w-full">
            <div class="vx-col lg:w-1/3 sm:w-full">
              <span class="span-placeholder">Nombre(s)</span>
              <input class="vs-input" label="Nombre(s)" v-model="nombre" name="username" />
            </div>
            <div class="vx-col lg:w-1/3 sm:w-full">
              <span class="span-placeholder">Apellido paterno</span>
              <input class="vs-input" label="Apellido Paterno" v-model="apellidoPaterno" name="name" />
            </div>
            <div class="vx-col lg:w-1/3 sm:w-full">
              <span class="span-placeholder">Apellido materno</span>
              <input class="vs-input" label="Apellido Materno" v-model="apellidoMaterno" name="name" />
             
            </div>
        </div>
        <div class="row w-full">
          <div class="col-md-3">
            <span for="sexo">Genero</span>
              <div class="alinear">
                <div class="col-md-4">
                  <span class="span-placeholder">Hombre</span>
                  <vs-radio v-model="sexo" vs-name="sexo" vs-value="H"></vs-radio>
                </div>
                <div class="col-md-4">
                  <span class="span-placeholder">Mujer</span>
                  <vs-radio v-model="sexo" vs-name="sexo" vs-value="M"></vs-radio>
                </div>
              </div>
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Teléfono celular</span>
            <input class="vs-input" label="Teléfono celular (10 dígitos)" v-model="telefono" name="username" />
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Teléfono fijo</span>
            <input class="vs-input" label="Teléfono fijo (10 dígitos)" v-model="adicionales.telefonoFijo" name="name" />
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Teléfono oficina</span>
            <input class="vs-input" label="Teléfono oficina (10 dígitos)" v-model="adicionales.telefonoOficina" name="name" />
          </div>
        </div>  
        <div class="row w-full">
          <div class="col-md-3">
            <span class="span-placeholder">Fecha de nacimiento</span>
            <input class="vs-input" label="Fecha de nacimiento" type="date" v-model="fechaNacimiento" name="fechaNacimiento" />
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">País de nacimiento</span>
            <select 
              name="name" 
              v-model="adicionales.paisNacimiento" 
              class="vs-input"
            >
              <option :value='pais.Nombre' v-for="pais in paisesNac" :key="">{{ pais.Nombre }}</option>
            </select>              
          </div>            
          <div class="col-md-3">
            <span class="span-placeholder" for="estados">Estado de nacimiento</span>
            <select name="cars" id="estados" v-model="adicionales.estadoNacimiento" class="vs-input">
              <option :value="''">seleccione...</option>
              <option :value="tipo.Id" v-for="tipo in estados" :key="">{{ tipo.Nombre }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Municipio de nacimiento</span>
            <input class="vs-input" label="Municipio de nacimiento" v-model="adicionales.municipioNacimiento" name="name" />
          </div>
        </div>

        <div class="row w-full">
          <div class="col-md-3" v-if="parentesco==1">
            <span class="span-placeholder" for="formasEnganche">Estado Civil</span>
            <select name="cars" id="formasEnganche" v-model="estadoCivil" class="vs-input" style="border: 1px solid rgba(0, 0, 0, 0.2);" >
              <option :value='1' >CASADO(A)</option>
            </select>
          </div>
          <div class="col-md-3">
            <span class="span-placeholder" for="nacionalidad">Nacionalidad</span>
            <select name="cars" id="nacionalidad" v-model="nacionalidad" class="vs-input">
              <option :value='tipo' v-for="tipo in nacionalidades"  :key="">{{tipo.Nombre}}</option>
              </select>
          </div>
        </div>


        <!-- DOMICILIO -->

        <div class="row w-full -mb-4" style="margin-top: 3%;">
          <div class="col-md-12">
            <h5 class="font-bold">Domicilio</h5> 
          </div>
			  </div>

        <div class="row w-full">
          <div class="col-md-3">
            <span class="span-placeholder">Calle</span>
            <input class="vs-input" label="Calle" v-model="calle" name="name" />
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Número exterior</span>
            <input class="vs-input" label="Número exterior" v-model="numeroExterior" name="name" />
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Número interior</span>
            <input class="vs-input" label="Número interior" v-model="numeroInterior" name="username" />
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Código postal</span>
            <input class="vs-input" label="Código postal" v-model="codigoPostal" name="username" @blur="getColoniaMunicipio(1)"/>
          </div>
        </div>
        <div class="row w-full">
          <div class="col-md-3">
            <span class="span-placeholder" v-if="LabelColoniaObligado">Colonia *</span>
            <span class="span-placeholder" v-if="LabelColoniaNoObligado">Colonia </span>
            <select 
              v-model="colonia" 
              name="colonia" class="vs-input">
              <option value="" selected>Selecciona una colonia</option>
              <option :value='colonia' v-for="colonia in ColoniasCP" :key="">{{colonia}}</option>
            </select>
            <span class="text-danger span-placeholder" v-if="LabelColoniaObligadoText">Campo requerido</span>
          </div>
          <div class="col-md-3">
            <span class="span-placeholder" for="estado">Estado</span>
            <select name="cars" id="estado" v-model="estado" class="vs-input" style="border: 1px solid rgba(0, 0, 0, 0.2);">
              <option :value="''">seleccione...</option>
              <option :value='tipo.Id' v-for="tipo in estados"  :key="">{{tipo.Nombre}}</option>
            </select>
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Ciudad</span>
            <input class="vs-input" label="Ciudad" v-model="ciudad" name="name" />
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Municipio</span>
            <input class="vs-input" label="Municipio" v-model="municipio" name="name" disabled/>
          </div>
        </div>
        <div class="row w-full">
          <div class="col-md-4">
            <span class="span-placeholder" for="domicilioOcupaciones">Titularidad de domicilio actual</span>
            <select name="cars" id="domicilioOcupaciones" v-model="adicionales.titularidadDomicilio" class="vs-input">
              <option :value="''">seleccione...</option>
              <option :value="tipo.Id" v-for="tipo in domicilioOcupaciones">{{ tipo.Nombre }}</option>
            </select>
          </div>
          <div class="col-md-4">
            <span class="span-placeholder">Tiempo ocupando el domicilio actual</span>            
            <div class="flex">                
                <span class="col-4">
                    <input 
                        class="vs-input input-antiguedad-am"
                        label="Tiempo ocupando el domicilio actual"
                        v-model="adicionales.tiempoOcupandoDomicilioActual"
                        name="name"/>
                </span>
                <span 
                    class="col-2 input-antiguedad-fecha">
                    <span>A</span>
                </span>
                <span class="col-4">
                    <input 
                        class="vs-input input-antiguedad-am"
                        label="Tiempo ocupando el domicilio actual"
                        v-model="adicionales.tiempoOcupandoDomicilioActualMeses"
                        name="name"/>
                </span>
                <span 
                    class="col-2 input-antiguedad-fecha">
                    <span>M</span>
                </span>
            </div>
          </div>
              <!--<div class="col-md-4">
                <span class="span-placeholder">Antigüedad Domicilio Anterior en años</span>
                <input class="vs-input" label="Antigüedad Domicilio Anterior en años" v-model="adicionales.antiguedadDomicilioAnterior" name="name" v-on:keypress="isNumber($event)" />
              </div>
            -->
          <div class="col-md-1"></div>
          <div class="col-md-3">
            <span class="span-placeholder">Antigüedad en la ciudad</span>         
            <div class="flex">
                
                <span class="col-4">
                    <input                        
                        class=" vs-input  input-antiguedad-am"
                        label="Antigüedad en la ciudad"
                        v-model="adicionales.antiguedadCiudad"
                        v-on:keypress="isNumber($event)"
                        name="username"/>
                </span>
                <span 
                    class="col-2 input-antiguedad-fecha">
                    <span>A</span>
                </span>

                <span class="col-4">
                    <input                        
                        class="vs-input input-antiguedad-am"
                        label="Antigüedad en la ciudad"
                        v-model="adicionales.antiguedadCiudadMeses"
                        v-on:keypress="isNumber($event)"
                        name="username"/>
                </span>
                <span 
                    class="col-2 input-antiguedad-fecha">
                    <span>M</span>
                </span>

            </div>

          </div>
        </div>

        <!-- PERSONALES -->

        <div class="row w-full -mb-4" style="margin-top: 3%;">
          <div class="col-md-12">
            <h5 class="font-bold">Personales</h5> 
          </div>
        </div>

        <div class="row w-full">
          <div class="col-md-4">
            <span class="span-placeholder" for="estados">Identificación que presenta</span>
            <select name="cars" id="estados" v-model="adicionales.identificacionPresenta" class="vs-input">
              <option :value="''">seleccione...</option>
              <option :value="tipo.Id" v-for="tipo in identificaciones" :key="">{{ tipo.Nombre }}</option>
            </select>
          </div>        
          <div class="col-md-4">
            <span class="span-placeholder">Número de identificación</span>
            <input class="vs-input" label="Número de identificación" v-model="adicionales.numeroIfe" name="name" />
          </div>
          <div class="col-md-4">
            <span class="span-placeholder">Vigencia de identificación</span>
            <input class="vs-input" label="Vigencia Identificación" type="date" v-model="adicionales.vigencia" name="name" />
          </div>
        </div>
        <div class="row w-full">
          <div class="col-md-3">
            <span class="span-placeholder">Número de seguro social</span>
            <input class="vs-input" label="Número de seguro social" v-model="adicionales.nss" name="name" />
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Número de ISSSTE</span>
            <input class="vs-input" label="Número de ISSSTE" v-model="adicionales.issste" name="name" />
          </div>
          <div class="col-md-3">
            <vx-tooltip text="Requerido por: HSBC, INBURSA">
              <span class="span-placeholder">FIEL</span>
              <input class="vs-input" label="FIEL" v-model="adicionales.fiel" name="name" />
            </vx-tooltip>
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Compañia celular</span>        
            <select name="cars" v-model="adicionales.companiaCelular" class="vs-input">
              <option :value="''">Seleccione...</option>
              <option :value="compania.name" v-for="compania in companiasCelular" :key="compania.name">{{ compania.name }}</option>
            </select>
          </div>
        </div>
        <div class="row w-full">
          <div class="col-md-3">
            <span class="span-placeholder" for="grados">Máximo grado de estudios</span>
            <select name="cars" id="grados" v-model="adicionales.gradoEstudios" class="vs-input">
              <option :value="''">seleccione...</option>
              <option :value="tipo.Id" v-for="tipo in gradosEstudio" :key="">{{ tipo.Nombre }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Tipo de institución de estudios</span>
            <input class="vs-input" label="Tipo de institución de estudios" 
              v-model="adicionales.institucionEstudios" name="name" placeholder="Pública o Privada" />
          </div>
          <div class="col-md-6">
            <span class="span-placeholder">En caso de haber tenido otro nombre favor de indicarlo</span>
            <input class="vs-input" label="En caso de haber tenido otro nombre favor de indicarlo" v-model="adicionales.otroNombre" name="name" />
          </div>
        </div>    

        <!-- DOMICILIO DE CIUDADANO EXTRANJERO -->

        <div class="row w-full -mb-4" style="margin-top: 3%;">
          <div class="col-md-12">
            <h5 class="font-bold">Domicilio de ciudadano extranjero</h5> 
          </div>
        </div>

        <div class="row w-full">
          <div class="col-md-3">
            <span class="span-placeholder">Calle</span>
            <input class="vs-input" label="Calle" v-model="adicionales.calleExtranjero" name="name" />
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Número exterior</span>
            <input class="vs-input" label="Número exterior" v-model="adicionales.numeroExteriorExtranjero" name="name" />
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Número interior</span>
            <input class="vs-input" label="Número interior" v-model="adicionales.numeroInteriorExtranjero" name="name" />
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Colonia</span>
            <input class="vs-input" label="Colonia" v-model="adicionales.coloniaExtranjero" name="name" />
          </div>       
        </div>
        <div class="row w-full">							
          <div class="col-md-4">
            <span class="span-placeholder">Código postal</span>
            <input class="vs-input" label="Código postal" v-model="adicionales.codigoPostalExtranjero" name="name" />
          </div>
          <div class="col-md-4">
            <span class="span-placeholder">Estado</span>
            <input class="vs-input" label="Estado" v-model="adicionales.estadoExtranjero" name="name" />
          </div>
          <div class="col-md-4">
            <span class="span-placeholder">País</span>
            <select 
              name="name" 
              v-model="adicionales.paisExtranjero" 
              class="vs-input"
            >
              <option :value='pais.Nombre' v-for="pais in paisesNac" :key="">{{ pais.Nombre }}</option>
            </select>								
          </div>							
        </div>

        <div class="row w-full -mb-4" style="margin-top: 3%;">
          <div class="col-md-12">
            <h5 class="font-bold">Conyugue</h5>
          </div>
        </div>

        <!-- conyugeDomicilioIgualSolicitante: domicilio del cónyuge igual al del solicitante titular (DameSolicitante) -->
        <div class="row w-full" style="margin-top: 1%; align-items: center;">
          <div class="col-md-12" style="display: flex; align-items: center;">
            <span class="span-placeholder" for="">Solicitante</span>
            <vs-switch v-model="conyugeDomicilioIgualSolicitante" style="margin-left: 0.5rem;" />
          </div>
        </div>

        <div class="row w-full" style="margin-top: 1%;">
          <div class="col-md-3">
            <span class="span-placeholder">Nombre</span>
            <input
              :disabled="conyugeDomicilioIgualSolicitante"
              :class="[conyugeDomicilioIgualSolicitante ? 'vs-input bg-toggle-disable' : 'vs-input bg-toggle-enable']"
              label="Nombre"
              v-model="nombreConyuge"
              name="nombreConyuge"
              maxlength="50"
              v-on:keypress="soloLetras($event)"
            />
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Segundo nombre</span>
            <input
              :disabled="conyugeDomicilioIgualSolicitante"
              :class="[conyugeDomicilioIgualSolicitante ? 'vs-input bg-toggle-disable' : 'vs-input bg-toggle-enable']"
              label="Segundo nombre"
              v-model="segundoNombreConyuge"
              name="segundoNombreConyuge"
              maxlength="50"
              v-on:keypress="soloLetras($event)"
            />
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Apellido paterno</span>
            <input
              :disabled="conyugeDomicilioIgualSolicitante"
              :class="[conyugeDomicilioIgualSolicitante ? 'vs-input bg-toggle-disable' : 'vs-input bg-toggle-enable']"
              label="Apellido paterno"
              v-model="apellidoPaternoConyuge"
              name="apellidoPaternoConyuge"
              maxlength="50"
              v-on:keypress="soloLetras($event)"
            />
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Apellido materno</span>
            <input
              :disabled="conyugeDomicilioIgualSolicitante"
              :class="[conyugeDomicilioIgualSolicitante ? 'vs-input bg-toggle-disable' : 'vs-input bg-toggle-enable']"
              label="Apellido materno"
              v-model="apellidoMaternoConyuge"
              name="apellidoMaternoConyuge"
              maxlength="50"
              v-on:keypress="soloLetras($event)"
            />
          </div>
        </div>
        <div class="row w-full">
          <div class="col-md-4">
            <span class="span-placeholder">Correo electrónico</span>
            <input
              :disabled="conyugeDomicilioIgualSolicitante"
              :class="[conyugeDomicilioIgualSolicitante ? 'vs-input bg-toggle-disable' : 'vs-input bg-toggle-enable']"
              label="Correo electrónico"
              v-model="correoElectronicoConyuge"
              name="correoElectronicoConyuge"
              type="email"
              maxlength="100"
              v-validate="'email|max:100'"
            />
            <span class="text-danger span-placeholder" v-show="errors.has('correoElectronicoConyuge')">Correo inválido</span>
          </div>
          <div class="col-md-4">
            <span class="span-placeholder">Fecha de nacimiento</span>
            <input
              :disabled="conyugeDomicilioIgualSolicitante"
              :class="[conyugeDomicilioIgualSolicitante ? 'vs-input bg-toggle-disable' : 'vs-input bg-toggle-enable']"
              label="Fecha de nacimiento"
              type="date"
              v-model="fechaNacimientoConyuge"
              name="fechaNacimientoConyuge"
              :max="fechaMaxima"
            />
          </div>
          <div class="col-md-4">
            <span for="sexoConyugeGrid">Género</span>
            <div class="alinear">
              <div class="col-md-4">
                <span class="span-placeholder">Hombre</span>
                <vs-radio
                  :disabled="conyugeDomicilioIgualSolicitante"
                  v-model="sexoConyuge"
                  vs-name="sexoConyugeGrid"
                  vs-value="H"
                ></vs-radio>
              </div>
              <div class="col-md-4">
                <span class="span-placeholder">Mujer</span>
                <vs-radio
                  :disabled="conyugeDomicilioIgualSolicitante"
                  v-model="sexoConyuge"
                  vs-name="sexoConyugeGrid"
                  vs-value="M"
                ></vs-radio>
              </div>
            </div>
          </div>
        </div>
        <div class="row w-full">
          <div class="col-md-4">
            <span class="span-placeholder">CURP cónyuge</span>
            <input
              :disabled="conyugeDomicilioIgualSolicitante"
              :class="[conyugeDomicilioIgualSolicitante ? 'vs-input bg-toggle-disable' : 'vs-input bg-toggle-enable']"
              label="CURP cónyuge"
              v-model="curpConyuge"
              name="curpConyuge"
              v-validate="'min:18|max:18'"
              maxlength="18"
              @input="curpConyuge = ($event.target.value || '').toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,18)"
            />
            <span class="text-danger span-placeholder" v-show="errors.has('curpConyuge')">El campo debe tener 18 caracteres</span>
          </div>
          <div class="col-md-4">
            <span class="span-placeholder">RFC cónyuge</span>
            <input
              :disabled="conyugeDomicilioIgualSolicitante"
              :class="[conyugeDomicilioIgualSolicitante ? 'vs-input bg-toggle-disable' : 'vs-input bg-toggle-enable']"
              label="RFC cónyuge"
              v-model="rfcConyuge"
              name="rfcConyuge"
              v-validate="'min:13|max:13'"
              maxlength="13"
              @input="rfcConyuge = ($event.target.value || '').toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,13)"
            />
            <span class="text-danger span-placeholder" v-show="errors.has('rfcConyuge')">El campo debe tener 13 caracteres</span>
          </div>
          <div class="col-md-4">
            <span class="span-placeholder" for="nacionalidadConyugeExtranjero">Nacionalidad</span>
            <select
              :disabled="conyugeDomicilioIgualSolicitante"
              :class="[conyugeDomicilioIgualSolicitante ? 'vs-input bg-toggle-disable' : 'vs-input bg-toggle-enable']"
              id="nacionalidadConyugeExtranjero"
              name="nacionalidadConyugeExtranjero"
              v-model="nacionalidadConyuge"
              class="vs-input"
            >
              <option :value="''">Seleccione...</option>
              <option :value="nat" v-for="nat in nacionalidades" :key="'natc-'+nat.Id">{{ nat.Nombre }}</option>
            </select>
          </div>
        </div>
        <div class="row w-full">
          <div class="col-md-4">
            <span class="span-placeholder" for="estadoNacimientoConyuge">Estado de nacimiento</span>
            <select
              id="estadoNacimientoConyuge"
              name="estadoNacimientoConyuge"
              :disabled="conyugeDomicilioIgualSolicitante"
              v-model="estadoNacimientoConyuge"
              :class="[conyugeDomicilioIgualSolicitante ? 'vs-input bg-toggle-disable' : 'vs-input bg-toggle-enable']"
            >
              <option :value="''">seleccione...</option>
              <option :value="tipo.Id" v-for="tipo in estados" :key="'enc-' + tipo.Id">{{ tipo.Nombre }}</option>
            </select>
          </div>
          <div class="col-md-4">
            <span class="span-placeholder">Teléfono</span>
            <input
              :disabled="conyugeDomicilioIgualSolicitante"
              :class="[conyugeDomicilioIgualSolicitante ? 'vs-input bg-toggle-disable' : 'vs-input bg-toggle-enable']"
              label="Teléfono"
              v-model="telefonoConyuge"
              name="telefonoConyuge"
              maxlength="10"
              @input="telefonoConyuge = ($event.target.value || '').replace(/\D/g, '').slice(0, 10)"
              v-validate="'min:10|max:10'"
              v-on:keypress="isNumber($event)"
            />
            <span class="text-danger span-placeholder" v-show="errors.has('telefonoConyuge')">El campo debe tener 10 caracteres</span>
          </div>
          <div class="col-md-4">
            <span class="span-placeholder">Celular</span>
            <input
              :disabled="conyugeDomicilioIgualSolicitante"
              :class="[conyugeDomicilioIgualSolicitante ? 'vs-input bg-toggle-disable' : 'vs-input bg-toggle-enable']"
              label="Celular"
              v-model="celularConyuge"
              name="celularConyuge"
              maxlength="10"
              @input="celularConyuge = ($event.target.value || '').replace(/\D/g, '').slice(0, 10)"
              v-validate="'min:10|max:10'"
              v-on:keypress="isNumber($event)"
            />
            <span class="text-danger span-placeholder" v-show="errors.has('celularConyuge')">El campo debe tener 10 caracteres</span>
          </div>
        </div>

        <!-- Domicilio de conyugue -->
        <div class="row w-full -mb-4" style="margin-top: 3%;">
          <div class="col-md-12">
            <h5 class="font-bold">Domicilio de conyugue</h5>
          </div>
        </div>
        <div class="row w-full">
          <div class="col-md-3">
            <span class="span-placeholder">Calle</span>
            <input
              :disabled="conyugeDomicilioIgualSolicitante"
              :class="[conyugeDomicilioIgualSolicitante ? 'vs-input bg-toggle-disable' : 'vs-input bg-toggle-enable']"
              label="Calle"
              v-model="calleConyuge"
              name="calleConyuge"
              maxlength="50"
              @input="calleConyuge = formatoAlfanumericoCalleConyuge($event.target.value)"
            />
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Número exterior</span>
            <input
              :disabled="conyugeDomicilioIgualSolicitante"
              :class="[conyugeDomicilioIgualSolicitante ? 'vs-input bg-toggle-disable' : 'vs-input bg-toggle-enable']"
              label="Número exterior"
              v-model="numeroExteriorConyuge"
              name="numeroExteriorConyuge"
              maxlength="10"
              @input="numeroExteriorConyuge = formatoAlfanumericoNumeroConyuge($event.target.value)"
            />
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Número interior</span>
            <input
              :disabled="conyugeDomicilioIgualSolicitante"
              :class="[conyugeDomicilioIgualSolicitante ? 'vs-input bg-toggle-disable' : 'vs-input bg-toggle-enable']"
              label="Número interior"
              v-model="numeroInteriorConyuge"
              name="numeroInteriorConyuge"
              maxlength="10"
              @input="numeroInteriorConyuge = formatoAlfanumericoNumeroConyuge($event.target.value)"
            />
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Código postal</span>
            <input
              :disabled="conyugeDomicilioIgualSolicitante"
              :class="[conyugeDomicilioIgualSolicitante ? 'vs-input bg-toggle-disable' : 'vs-input bg-toggle-enable']"
              label="Código postal"
              v-model="codigoPostalConyuge"
              name="codigoPostalConyuge"
              minlength="5"
              maxlength="5"
              v-on:blur="getColoniaMunicipioConyuge(1)"
              v-on:keypress="isNumber($event)"
              @input="codigoPostalConyuge = ($event.target.value || '').replace(/\D/g, '').slice(0, 5)"
            />
          </div>
        </div>
        <div class="row w-full">
          <div class="col-md-3">
            <span class="span-placeholder" v-if="LabelColoniaObligadoConyuge">Colonia *</span>
            <span class="span-placeholder" v-if="LabelColoniaNoObligadoConyuge">Colonia</span>
            <select
              id="coloniaConyuge"
              name="coloniaConyuge"
              v-model="coloniaConyuge"
              :disabled="conyugeDomicilioIgualSolicitante"
              :class="[conyugeDomicilioIgualSolicitante ? 'vs-input bg-toggle-disable' : 'vs-input bg-toggle-enable']"
              style="border: 1px solid rgba(0, 0, 0, 0.2);"
            >
              <option value="" selected>Selecciona una colonia</option>
              <option :value="colNom" v-for="colNom in ColoniasCPConyuge" :key="colNom">{{ colNom }}</option>
            </select>
            <span class="text-danger span-placeholder" v-if="LabelColoniaObligadoTextConyuge">Campo requerido</span>
          </div>
          <div class="col-md-3">
            <span class="span-placeholder" for="estadoConyuge">Estado</span>
            <select
              id="estadoConyuge"
              name="estadoConyuge"
              :disabled="conyugeDomicilioIgualSolicitante"
              v-model="estadoConyuge"
              :class="[conyugeDomicilioIgualSolicitante ? 'vs-input bg-toggle-disable' : 'vs-input bg-toggle-enable']"
              style="border: 1px solid rgba(0, 0, 0, 0.2);"
            >
              <option :value="''">seleccione...</option>
              <option :value="tipo.Id" v-for="tipo in estados" :key="tipo.Id">{{ tipo.Nombre }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Ciudad</span>
            <input
              :disabled="conyugeDomicilioIgualSolicitante"
              :class="[conyugeDomicilioIgualSolicitante ? 'vs-input bg-toggle-disable' : 'vs-input bg-toggle-enable']"
              label="Ciudad"
              v-model="ciudadConyuge"
              name="ciudadConyuge"
              maxlength="50"
              v-on:keypress="soloLetras($event)"
              @input="ciudadConyuge = (textFormat($event.target.value || '').replace(/[0-9]/g,'')).slice(0, 50)"
            />
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Municipio</span>
            <input
              class="vs-input"
              :class="[conyugeDomicilioIgualSolicitante ? 'bg-toggle-disable' : 'bg-toggle-enable']"
              label="Municipio"
              v-model="municipioConyuge"
              name="municipioConyuge"
              disabled
            />
          </div>
        </div>

        <!-- VEHICULOS Y EXTRAS -->

        <div class="row w-full">
          <div class="col-md-12">
            <ul class="con-s" style="margin-top: 3%">
              <li>
                <span for="">¿Participa en crédito Infonavit o Fovissste (Banamex)?</span>
                <vs-switch v-model="adicionales.participaCreditoInfonavit" />
              </li>
            </ul>
          </div>
        </div>
        <div class="row w-full">
          <div class="col-md-12">
            <ul class="con-s" style="margin-top: 1%">
              <li>
                <span for="">¿Tiene Autos propios?</span>
                <vs-switch v-model="adicionales.autosPropios" />
              </li>
            </ul>
          </div>
        </div>

        <div v-if="adicionales.autosPropios">
          <div class="row w-full -mb-4" style="margin-top: 3%;">
            <div class="col-md-12">
              <h5 class="font-bold">Vehículos</h5> 
            </div>
          </div>
          <div class="row w-full">
            <div class="col-md-4">
              <span class="span-placeholder">Número de autos</span>
              <input class="vs-input" label="Número de autos" v-model="adicionales.vehiculos.numero" name="name" v-on:keypress="isNumber($event)" />
            </div>
            <div class="col-md-6"></div>
          </div>
          <div class="row w-full">
            <div class="col-md-4">
              <span class="span-placeholder">Valor aproximado vehículo 1</span>
              <input class="vs-input" label="Valor aproximado vehículo 1" v-model="adicionales.vehiculos.valor" name="name" v-on:keypress="isNumber($event)" />
            </div>
            <div class="col-md-4">
              <span class="span-placeholder">Marca vehículo 1</span>
              <input class="vs-input" label="Marca vehículo 1" v-model="adicionales.vehiculos.marca" name="name" />
            </div>
            <div class="col-md-4">
              <span class="span-placeholder">Modelo vehículo 1</span>
              <input class="vs-input" label="Modelo vehículo 1" v-model="adicionales.vehiculos.modelo" name="name" />
            </div>
          </div>
          <div class="row w-full">
            <div class="col-md-4">
              <span class="span-placeholder" for="grados">Año vehículo 1</span>
              <select name="cars" id="grados" v-model="adicionales.vehiculos.anio" class="vs-input">
                <option :value="''">seleccione...</option>
                <option :value="tipo.Id" v-for="tipo in años" :key="">{{ tipo.Nombre }}</option>
              </select>
            </div>
            <div class="col-md-8 text-center">
              <span class="span-placeholder" for="pago">Pago vehículo 1</span>
              <div class="row">
                <div class="col-md-6 content-radio">
                  <vs-radio v-model="adicionales.vehiculos.pago" vs-name="pago" name="pago" vs-value="Completo"></vs-radio>
                  <span class="span-placeholder" for="Completo">Completo</span>
                </div>
                <div class="col-md-6 content-radio">
                  <vs-radio v-model="adicionales.vehiculos.pago" vs-name="pago" name="pago" vs-value="Parcial"></vs-radio>
                  <span class="span-placeholder" for="Parcial">Parcial</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row w-full">
            <div class="col-md-4">
              <span class="span-placeholder">Valor aproximado vehículo 2</span>
              <input class="vs-input" label="Valor aproximado vehículo 2" v-model="adicionales.vehiculos.valor2" name="name" v-on:keypress="isNumber($event)" />
            </div>
            <div class="col-md-4">
              <span class="span-placeholder">Marca vehículo 2</span>
              <input class="vs-input" label="Marca vehículo 2" v-model="adicionales.vehiculos.marca2" name="name" />
            </div>
            <div class="col-md-4">
              <span class="span-placeholder">Modelo vehículo 2</span>
              <input class="vs-input" label="Modelo vehículo 2" v-model="adicionales.vehiculos.modelo2" name="name" />
            </div>
          </div>
          <div class="row w-full">
            <div class="col-md-4">
              <span class="span-placeholder" for="grados">Año vehículo 2</span>
              <select name="cars" id="grados" v-model="adicionales.vehiculos.anio2" class="vs-input">
                <option :value="''">seleccione...</option>
                <option :value="tipo.Id" v-for="tipo in años" :key="">{{ tipo.Nombre }}</option>
              </select>
            </div>
            <div class="col-md-8 text-center">
              <span class="span-placeholder" for="pago2">Pago vehículo 2</span>
              <div class="row">
                <div class="col-md-6 content-radio">
                  <vs-radio v-model="adicionales.vehiculos.pago2" vs-name="pago2" name="pago2" vs-value="Completo"></vs-radio>
                  <span class="span-placeholder" for="Completo">Completo</span>
                </div>
                <div class="col-md-6 content-radio">
                  <vs-radio v-model="adicionales.vehiculos.pago2" vs-name="pago2" name="pago2" vs-value="Parcial"></vs-radio>
                  <span class="span-placeholder" for="Parcial">Parcial</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      
       
        
          
         
         
        
      


            

          
          

<!-- ------------------------------------------------------------------------------------------------------------------------------------------------------------------------- -->

      <!--
        <vx-card :title="'Coacreditado: '+email" class="">          
          <vs-row vs-type="flex" vs-justify="flex-end">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="12">
              <vs-button color="danger"  @click="eliminarCoacreditado()">Eliminar Coacreditado</vs-button>
            </vs-col>
          </vs-row>
          <div class="row w-full" style="margin-top:2%">
            <div class="vx-col lg:w-1/3 sm:w-full">
              <span class="span-placeholder">Nombre(s)</span>
              <input class="vs-input" label="Nombre(s)" v-model="nombre" name="username" />
            </div>
            <div class="vx-col lg:w-1/3 sm:w-full">
              <span class="span-placeholder">Apellido Paterno</span>
              <input class="vs-input" label="Apellido Paterno" v-model="apellidoPaterno" name="name" />
            </div>
            <div class="vx-col lg:w-1/3 sm:w-full">
              <span class="span-placeholder">Apellido Materno</span>
              <input class="vs-input" label="Apellido Materno" v-model="apellidoMaterno" name="name" />
            </div>
          </div>
          <div class="row w-full">
            <div class="vx-col lg:w-1/3 sm:w-full">
              <span class="span-placeholder">Teléfono celular (10 dígitos)</span>
              <input class="vs-input" label="Teléfono celular (10 dígitos)" v-model="telefono" name="username" />
            </div>
            <div class="vx-col lg:w-1/3 sm:w-full">
              <span class="span-placeholder">Fecha de nacimiento</span>
              <input class="vs-input" label="Fecha de nacimiento" type="date" v-model="fechaNacimiento" name="fechaNacimiento" />
            </div>
            <div class="vx-col lg:w-1/3 sm:w-full" v-if="parentesco!=1">
              <span class="span-placeholder" for="formasEnganche">Estado Civil</span>
              <select name="cars" id="formasEnganche" v-model="estadoCivil" class="vs-input" style="border: 1px solid rgba(0, 0, 0, 0.2);" @change="dameConyuge()">
                <option :value="''">seleccione...</option>
                <option :value='tipo.Id' v-for="tipo in estadosCiviles"  :key="">{{tipo.Nombre}}</option>
              </select>
            </div>
            <div class="vx-col lg:w-1/3 sm:w-full" v-if="parentesco==1">
              <span class="span-placeholder" for="formasEnganche">Estado Civil</span>
              <select name="cars" id="formasEnganche" v-model="estadoCivil" class="vs-input" style="border: 1px solid rgba(0, 0, 0, 0.2);" >
                <option :value='1' >CASADO(A)</option>
              </select>
            </div>
          </div>
          <div class="row w-full">
            <div class="col-md-4">
              <span class="span-placeholder">RFC</span>
              <input class="vs-input" label="RFC" v-model="rfc" name="username" />
            </div>
            <div class="col-md-4">
              <span class="span-placeholder">CURP</span>
              <input class="vs-input" label="Curp" v-model="curp" name="username" />
            </div>
            
              <div class="col-md-4">

                <span for="sexo">Sexo</span>
                <div class="alinear">
                <div class="col-md-4">
                  <span class="span-placeholder">Hombre</span>
                  <vs-radio v-model="sexo" vs-name="sexo" vs-value="H"></vs-radio>
                </div>
                <div class="col-md-4">
                  <span class="span-placeholder">Mujer</span>
                  <vs-radio v-model="sexo" vs-name="sexo" vs-value="M"></vs-radio>
                </div>
                </div>
              </div>
            
          </div>
          <div class="row w-full">
            <div class="col-md-3">
              <span class="span-placeholder">Calle</span>
              <input class="vs-input" label="Calle" v-model="calle" name="name" />
            </div>
            <div class="col-md-3">
              <span class="span-placeholder">Número exterior</span>
              <input class="vs-input" label="Número exterior" v-model="numeroExterior" name="name" />
            </div>
            <div class="col-md-3">
              <span class="span-placeholder">Número interior</span>
              <input class="vs-input" label="Número interior" v-model="numeroInterior" name="username" />
            </div>
            <div class="col-md-3">
              <span class="span-placeholder">Código postal</span>
              <input class="vs-input" label="Código postal" v-model="codigoPostal" name="username" @blur="getColoniaMunicipio(1)"/>
            </div>
          </div>
          <div class="row w-full">
            <div class="vx-col lg:w-1/3 sm:w-full">
              <span class="span-placeholder">Municipio</span>
              <input class="vs-input" label="Municipio" v-model="municipio" name="name" disabled/>
            </div>
            <div class="vx-col lg:w-1/3 sm:w-full">
              <span class="span-placeholder" v-if="LabelColoniaObligado">Colonia *</span>
              <span class="span-placeholder" v-if="LabelColoniaNoObligado">Colonia </span>
              <select 
                v-model="colonia" 
                name="colonia" class="vs-input">
                <option value="" selected>Selecciona una colonia</option>
                <option :value='colonia' v-for="colonia in ColoniasCP" :key="">{{colonia}}</option>
              </select>
              <span class="text-danger span-placeholder" v-if="LabelColoniaObligadoText">Campo requerido</span>
            </div>
            <div class="vx-col lg:w-1/3 sm:w-full">
              <span class="span-placeholder">Ciudad</span>
              <input class="vs-input" label="Ciudad" v-model="ciudad" name="name" />
            </div>

          </div>
          <div class="row w-full">
            <div class="vx-col lg:w-1/3 sm:w-full">
              <span class="span-placeholder" for="estado">Estado</span>
              <select name="cars" id="estado" v-model="estado" class="vs-input" style="border: 1px solid rgba(0, 0, 0, 0.2);">
                <option :value="''">seleccione...</option>
                <option :value='tipo.Id' v-for="tipo in estados"  :key="">{{tipo.Nombre}}</option>
              </select>
            </div>
            <div class="vx-col lg:w-1/3 sm:w-full">
             <span class="span-placeholder" for="nacionalidad">Nacionalidad</span>
              <select name="cars" id="nacionalidad" v-model="nacionalidad" class="vs-input">
                <option :value='tipo' v-for="tipo in nacionalidades"  :key="">{{tipo.Nombre}}</option>
               </select>
            </div>
            <div class="vx-col lg:w-1/3 sm:w-full">
              <div class="row" style="padding-top: 14%;">
                <div class="col-8">
                  <span class="span-placeholder">Domicilio de solicitante</span>
                </div>
                <div class="col-2">
                  <vs-switch  v-model="DomicilioIgual" @click="asgnaDomicilio()"/>  
                </div>
              </div>
              
                        
             </div>
          </div>
          <br>
          <h4 class="mb-2" v-if="estadoCivil == 1 && conyugeIsCoacred=='FALSE'">Conyuge coacreditado</h4>
          <div class="row w-full" v-if="estadoCivil == 1 && conyugeIsCoacred=='FALSE'">
            
             <div class="vx-col lg:w-1/3 sm:w-full">
             <span class="span-placeholder">Nombre(s) cónyuge*</span>
              <input class="vs-input" label="Nombre(s) cónyuge*" v-model="nombreConyuge" name="name"/>
            </div>
            <div class="vx-col lg:w-1/3 sm:w-full">
              <span class="span-placeholder">Apellido Paterno cónyuge*</span>
              <input class="vs-input" label="Apellido Paterno cónyuge*" v-model="apellidoPaternoConyuge" name="name"/>
            </div>
             <div class="vx-col lg:w-1/3 sm:w-full">
              <span class="span-placeholder">Apellido Materno cónyuge*</span>
              <input class="vs-input" label="Apellido Materno cónyuge*" v-model="apellidoMaternoConyuge" name="name"/>
            </div>
          </div>
          <div class="row w-full" v-if="estadoCivil == 1 && conyugeIsCoacred=='FALSE'">
            <div class="vx-col lg:w-1/3 sm:w-full" >
              <span class="span-placeholder">CURP cónyuge</span>
              <input class="vs-input" label="CURP cónyuge" v-model="curpConyuge" name="name"/>
            </div>
            <div class="vx-col lg:w-1/3 sm:w-full" >
              <span class="span-placeholder">RFC cónyuge</span>
              <input class="vs-input" label="RFC cónyuge" v-model="rfcConyuge" name="name"/>
            </div>
            <div class="vx-col lg:w-1/3 sm:w-full">
              <span class="span-placeholder">Fecha de nacimiento*</span>
              <input class="vs-input" label="Fecha de nacimiento*" type="date" v-model="fechaNacimientoConyuge" name="fechaNacimiento" />
            </div>
          </div>
           <div class="row w-full" v-if="estadoCivil == 1 && conyugeIsCoacred=='FALSE'">
            <div class="vx-col lg:w-1/6 sm:w-full">
              <span class="span-placeholder">Edad cónyuge</span>
              <input class="vs-input" label="Edad cónyuge" v-model="edadConyuge" name="name"/>
            </div>
            <div class="vx-col lg:w-1/3 sm:w-full">
               <span class="span-placeholder">Nacionalidad</span>
              <input class="vs-input" label="Nacionalidad" v-model="lugarNacimientoConyuge" name="name"/> 

              <span class="span-placeholder" for="lugarNacimientoConyuge">Nacionalidad</span>
              <select name="cars" id="lugarNacimientoConyuge" v-model="lugarNacimientoConyuge" class="vs-input">
                <option :value='tipo.Nombre' v-for="tipo in nacionalidades"  :key="">{{tipo.Nombre}}</option>
              </select>

            </div>
            <div class="vx-col lg:w-1/6 sm:w-full">
              <ul class="leftx">
                <span for="sexo">Sexo</span>
                <li>
                  <vs-radio v-model="sexoConyuge" vs-name="sexo" vs-value="Hombre">Hombre</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="sexoConyuge" vs-name="sexo" vs-value="Mujer">Mujer</vs-radio>
                </li>
              </ul>
            </div>
            <div class="vx-col lg:w-1/3 sm:w-full">
              <input class="vs-input" label="Domicilio (Calle y número) cónyuge" v-model="domicilioConyuge" name="name"/>
            </div>
          </div>
          <div class="row w-full" v-if="estadoCivil == 1 && conyugeIsCoacred=='FALSE'">
            <div class="vx-col lg:w-1/3 sm:w-full">
              <span class="span-placeholder">Colonia cónyuge</span>
              <input class="vs-input" label="Colonia cónyuge" v-model="coloniaConyuge" name="name"/>
            </div>
            <div class="vx-col lg:w-1/3 sm:w-full">
              <span class="span-placeholder">Municipio y entidad federativa cónyuge</span>
              <input class="vs-input" label="Municipio y entidad federativa cónyuge" v-model="municipioConyuge" name="name"/>
            </div>
            <div class="vx-col lg:w-1/6 sm:w-full">
                  <span class="span-placeholder">Código postal</span>
                  <input class="vs-input" label="Código postal" v-model="codigoPostalConyuge" name="name" />
            </div>
          </div>          
        </vx-card>

      -->
        <button class="btn btn-second" @click="actualizarInfo()" :disabled="!validateForm" style="margin-top: 5%;">Guardar información</button>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { nacionalidades } from '@/assets/jsonFiles/nacionalidades.js'
import { paisesNacimiento } from '@/assets/jsonFiles/paisesNacimiento.js'
export default {
  components:{
    'v-select': vSelect,
  },
  data(){
		return{
      id:'',
      key:'',
      email:'',
      nombre:'',
      apellidoPaterno:'',
      apellidoMaterno:'',
      telefono:'',
      fechaNacimiento:'',
      ingresosSinImpuestos:'',
      IngresosConImpuestos:'',
      estadoCivil:'',
      estadosCiviles:[],
      rfc:'',
      curp:'',
      sexo:'',
      calle:'',
      numeroInterior:'',
      numeroExterior:'',
      colonia:'',
      municipio:'',
      ColoniasCP: [],
      /** Colonias por CP para domicilio del cónyuge (misma lógica que Solicitante / domicilio coacreditado). */
      ColoniasCPConyuge: [],
			MunicipiosCP: [],
      ciudad:'',
      nacionalidad:'',
      estado:'',
      codigoPostal:'',
      estados:[],
      states: ['AGUASCALIENTES','BAJA CALIFORNIA NORTE','BAJA CALIFORNIA SUR','CAMPECHE',
      'CHIAPAS','CHIHUAHUA','COAHUILA','COLIMA','CIUDAD DE MEXICO','DURANGO','ESTADO DE MÉXICO',
      'GUANAJUATO','GUERRERO','HIDALGO','JALISCO','MICHOACAN','MORELOS','NAYARIT','NUEVO LEON',
      'OAXACA','PUEBLA','QUERETARO','QUINTANA ROO','SAN LUIS POTOSI','SINALOA','SONORA','TABASCO',
      'TAMAULIPAS','TLAXCALA','VERACRUZ','YUCATAN','ZACATECAS'],
      parentescos:[],
      paisesNac: [],
      solicitante:'',
      nombreConyuge:'',
      segundoNombreConyuge:'',
      apellidoPaternoConyuge:'',
      apellidoMaternoConyuge:'',
      rfcConyuge:'',
      curpConyuge:'',
      fechaNacimientoConyuge:'',
      edadConyuge:'',
      nacionalidadConyuge:'',
      lugarNacimientoConyuge:'',
      sexoConyuge:'',
      domicilioConyuge:'',
      calleConyuge: '',
      numeroExteriorConyuge: '',
      numeroInteriorConyuge: '',
      ciudadConyuge: '',
      estadoConyuge: '',
      coloniaConyuge:'',
      municipioConyuge:'',
      codigoPostalConyuge:'',
      /** Correo del cónyuge (sección Conyugue); pendiente enlazar a API si aplica. */
      correoElectronicoConyuge: '',
      estadoNacimientoConyuge: '',
      telefonoConyuge: '',
      celularConyuge: '',
      /** Snapshot Solicitante titular — mismo contrato que PersonalesGeneral.vue (DameSolicitante Generales→Personales). */
      datosTitular: {
        nombres: '',
        segundoNombre: '',
        apellidoPaterno: '',
        apellidoMaterno: '',
        correoCliente: '',
        fechaNacimiento: '',
        sexo: '',
        curp: '',
        rfc: '',
        nacionalidad: '',
        estadoNacimiento: '',
        /** TelefonoCasa (Personales: adicionales.telefonoFijo). */
        telefonoCasa: '',
        /** TelefonoCelular (Personales: campo principal telefono). */
        telefonoCelular: '',
        /** TelefonoCelular2 (Personales: segundo celular). */
        telefonoCelular2: '',
        paisNacimiento: '',
        municipioNacimiento: '',
        calle: '',
        numeroExterior: '',
        numeroInterior: '',
        ciudad: '',
        estado: '',
        codigoPostal: '',
        municipio: '',
        colonia: '',
        estadoCivil: '',
      },
      solicitante:'',
      conyugeIsCoacred:'TRUE',
      // nacionalidades:[
      //   { label: 'MEXICANA',  value: 'MEXICANO' },
      //   { label: 'EXTRANJERA',  value: 'EXTRANJERO' }
      // ],
      nacionalidades: [],

      AccreditedidV3 : false,
			Coacreditado : false,
			// header: {
			// 		"authorization": "Bearer 16JXvQ9CD1eEoVESY3-4d-bElrAAgAfcB0UgYwAB-XyuNugkcBvgntr6n6VjEAFWenS9Exi_jlLv_RBfmf004TXytHP64dNEuSyhlXOBDtO56hW07txWd4evNWfukK5CO1ETRIOk8GWyjjS7daQ8eLHUz3XefoKEHKE0yIy76o8rZZYTGskAn1Zo3oKcPFzfs_fmVlO15cD_Kxx27-1qqDBsfAphhY7N599ly5ppo5L4XHaL8JAv6mTxXVYxrTZPQDmnLqQ9Nwre7Bd4URM5rR3rVMrAVkPzJ8ohQ9-pgvigB-Fra_SMi31c5T-QrSTB"
			// 		},
      header: {},
      tokenSisec: '',
      solicitanteV3 : '',
      SocGuid:'',
      BrokerId: '',
      Id:'',
      LabelColoniaObligado: false,
      LabelColoniaNoObligado: true,
      LabelColoniaObligadoText: true,
      LabelColoniaObligadoConyuge: false,
      LabelColoniaNoObligadoConyuge: true,
      LabelColoniaObligadoTextConyuge: false,
      DomicilioIgual : '',
      /** Sección Conyugue: indica si el domicilio del cónyuge coincide con el del solicitante (pendiente conectar guardado/comportamiento). */
      conyugeDomicilioIgualSolicitante: false,
      // DATOS ADICIONALES
      adicionales :{
        telefonoFijo:'',
        telefonoOficina:'',
        paisNacimiento: '',
        estadoNacimiento: '',
        municipioNacimiento:'',
        antiguedadDomicilioAnterior: '',
        tiempoOcupandoDomicilioActual: '',
        tiempoOcupandoDomicilioActualMeses: '',
        antiguedadCiudad: '',
        antiguedadCiudadMeses: '',
        titularidadDomicilio: '',
        identificacionPresenta: '',
        numeroIfe: '',
        vigencia: '',
        nss : '',
        issste: '',
        fiel: '',
        companiaCelular: '',
        gradoEstudios: '',
        institucionEstudios: '',
        otroNombre: '',
        calleExtranjero:'',
        numeroExteriorExtranjero:'',
        numeroInteriorExtranjero:'',
        coloniaExtranjero:'',
        estadoExtranjero:'',
        paisExtranjero:'',
        codigoPostalExtranjero:'',
        participaCreditoInfonavit:false,
        autosPropios:false,
        vehiculos:{
          numero:'',
          valor:'',
          marca:'',
          modelo:'',
          anio:'',
          pago: '',
          valor2:'',
          marca2:'',
          modelo2:'',
          anio2:'',
          pago2:''
        },





      }, 
      identificaciones:[],
      gradosEstudio:[],
      años:[],
      companiasCelular: [
        {name: 'Telcel'},
        {name: 'AT&T'},
        {name: 'Movistar'},
        {name: 'Unefon'},
        {name: 'Virgin Mobile'},
        {name: 'Freedompop'},
        {name: 'Flash Mobile'},
        {name: 'Weex'},
        {name: 'Cierto'},
        {name: 'Maz Tiempo'},
        {name: 'Oui móvil'},
        {name: 'Oxxo'},
        {name: 'Izzi móvil'},
        {name: 'Pillofon'},
        {name: 'BlueTelecomm'},
        {name: 'YO Mobile'},
        {name: 'Bait'},
        {name: 'Sky Celular'}
      ],
      error_apm: false
    }
  },
  mounted(){
    this.id=this.$route.params.id
    this.getPaisesNacimiento()    
    this.getNacionalidades()
    this.getApikey()
    this.dameCaso()
    this.getEstados()
    this.getEstadosCiviles()
    this.getListaParentescos()
    this.DameCredenciales()
    this.getListaDomicilioOcupaciones()
    this.getIdentificaciones()
    this.getGradosEstudio()
    this.getAños()
  },
  watch: {
		// Formato mayusculas sin acento
		nombre: function(newValue, oldValue) {
			this.nombre = this.textFormat(newValue);
		},
		apellidoPaterno: function(newValue, oldValue) {
			this.apellidoPaterno = this.textFormat(newValue);
		},
		apellidoMaterno: function(newValue, oldValue) {
			this.apellidoMaterno = this.textFormat(newValue);
		},
    solicitante: function() {
      this.cargarDatosTitularSolicitante();
    },
    conyugeDomicilioIgualSolicitante: function(newValue) {
      if (newValue) {
        this.cargarDatosTitularSolicitante();
      } else {
        // OFF: iniciar el bloque Conyugue limpio y editable (no mostrar lo último sincronizado).
        this.limpiarConyugeForm();
      }
    },
		nombreConyuge: function(newValue, oldValue) {
			this.nombreConyuge = this.textFormat(newValue).replace(/[0-9]/g, '');
		},
		segundoNombreConyuge: function(newValue, oldValue) {
			this.segundoNombreConyuge = this.textFormat(newValue).replace(/[0-9]/g, '');
		},
		apellidoPaternoConyuge: function(newValue, oldValue) {
			this.apellidoPaternoConyuge = this.textFormat(newValue).replace(/[0-9]/g, '');
		},
		apellidoMaternoConyuge: function(newValue, oldValue) {
			this.apellidoMaternoConyuge = this.textFormat(newValue).replace(/[0-9]/g, '');
		},
    nacionalidadConyuge: function(newValue) {
      // Puede ser string (legacy) u objeto del catálogo nacionalidades.
      if (newValue != null && typeof newValue === 'object') return;
      this.nacionalidadConyuge = this.textFormat(newValue).replace(/[0-9]/g, '').slice(0, 50);
    },
    lugarNacimientoConyuge: function(newValue) {
      this.lugarNacimientoConyuge = this.textFormat(newValue).replace(/[0-9]/g, '').slice(0, 50);
    },
    ciudadConyuge: function(newValue) {
      this.ciudadConyuge = this.textFormat(newValue).replace(/[0-9]/g, '').slice(0, 50);
    },
    vehiculosValor:function(newValue){
      if (this.adicionales.vehiculos.valor != null ) {
        this.adicionales.vehiculos.valor= newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }
    },
    vehiculosValor2:function(newValue){
      if (this.adicionales.vehiculos.valor2 != null ) {
        this.adicionales.vehiculos.valor2= newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }
    }
  },
  computed:{
    validateForm(){
      if ( (this.adicionales.paisNacimiento == "MÉXICO" || this.nacionalidad.Nombre == "MEXICANO (A)") && !this.apellidoMaterno) {
        this.error_apm = true
        return false
      }
      this.error_apm = false

      var ok = true

      if (this.codigoPostal == '' || this.codigoPostal == null) {
        this.LabelColoniaObligado = false
        this.LabelColoniaNoObligado = true
        this.LabelColoniaObligadoText = false
      } else {
        this.LabelColoniaObligado = true
        this.LabelColoniaNoObligado = false
        if (this.colonia) {
          this.LabelColoniaObligadoText = false
        } else {
          this.LabelColoniaObligadoText = true
        }
        ok = ok && this.colonia != ''
      }

      if (!this.conyugeDomicilioIgualSolicitante) {
        if (this.codigoPostalConyuge == '' || this.codigoPostalConyuge == null) {
          this.LabelColoniaObligadoConyuge = false
          this.LabelColoniaNoObligadoConyuge = true
          this.LabelColoniaObligadoTextConyuge = false
        } else {
          this.LabelColoniaObligadoConyuge = true
          this.LabelColoniaNoObligadoConyuge = false
          if (this.coloniaConyuge) {
            this.LabelColoniaObligadoTextConyuge = false
          } else {
            this.LabelColoniaObligadoTextConyuge = true
          }
          ok = ok && this.coloniaConyuge != ''
        }
      } else {
        this.LabelColoniaObligadoConyuge = false
        this.LabelColoniaNoObligadoConyuge = true
        this.LabelColoniaObligadoTextConyuge = false
      }

      return ok
    },
    vehiculosValor(){
      return this.adicionales.vehiculos.valor
    },
    vehiculosValor2(){
      return this.adicionales.vehiculos.valor2
    },
    fechaMaxima(){
      // Evita seleccionar fechas futuras en el campo de fecha de nacimiento
      const d = new Date();
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
  },
  methods:{
		// Conversion
		textFormat(strValue) {
			return strValue.normalize('NFD')
							.replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1")
							.normalize()
							.toUpperCase(); // Eliminar acentos menos Ññ
		},
		isNumber(evt) {
			evt = evt || window.event;
			var charCode = evt.which != null ? evt.which : evt.keyCode;
			if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
				evt.preventDefault();
			} else {
				return true;
			}
		},
    soloLetras(evt) {
      evt = evt || window.event;
      var charCode = evt.which != null ? evt.which : evt.keyCode;
      // Permite control keys (backspace, tab, enter), espacio, letras, acentos/ñ y guion/apóstrofe.
      if (charCode <= 31) return true;
      var ch = String.fromCharCode(charCode);
      if (/[0-9]/.test(ch)) {
        evt.preventDefault();
        return false;
      }
      return true;
    },
		/** Igual que PersonalesGeneral al leer TelefonoCelular / TelefonoCasa: limpia espacios, guiones y no dígitos. */
		normalizeTelefonoPersonales(val){
			if (val == null) return '';
			return String(val).replace(/\s+/g, '').replace(/-/g, '').replace(/\D/g, '').slice(0, 10);
		},
    getNacionalidadTexto(nacionalidad){
      if (!nacionalidad) return '';
      if (typeof nacionalidad === 'string') return nacionalidad;
      if (typeof nacionalidad === 'object' && nacionalidad.Nombre) return nacionalidad.Nombre;
      return '';
    },
    splitNombreCompleto(nombreCompleto){
      var raw = this.textFormat(String(nombreCompleto || '')).trim();
      if (!raw) {
        return { nombre: '', segundoNombre: '' };
      }
      var partes = raw.split(/\s+/).filter(function (p) { return p !== ''; });
      var nombre = partes.length ? partes[0] : '';
      var segundoNombre = partes.length > 1 ? partes.slice(1).join(' ') : '';
      return {
        nombre: nombre.slice(0, 50),
        segundoNombre: segundoNombre.slice(0, 50),
      };
    },
    composeNombreConyuge(){
      return [this.nombreConyuge, this.segundoNombreConyuge]
        .filter(function (x) { return x != null && String(x).trim() !== ''; })
        .join(' ')
        .trim()
        .slice(0, 100);
    },
    syncConyugeConSolicitante(){
      // Misma semántica que Solicitante → Generales → Personales (PersonalesGeneral dameSolicitante).
      const t = this.datosTitular;
      this.nombreConyuge = (this.textFormat(t.nombres || '')).slice(0, 50);
      this.segundoNombreConyuge = (this.textFormat(t.segundoNombre || '')).slice(0, 50);
      this.apellidoPaternoConyuge = (this.textFormat(t.apellidoPaterno || '')).slice(0, 50);
      this.apellidoMaternoConyuge = (this.textFormat(t.apellidoMaterno || '')).slice(0, 50);
      this.correoElectronicoConyuge = (t.correoCliente || this.solicitante || '').trim().slice(0, 100);
      this.fechaNacimientoConyuge = t.fechaNacimiento || '';
      this.sexoConyuge = t.sexo || '';
      this.curpConyuge = (t.curp || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 18);
      this.rfcConyuge = (t.rfc || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 13);
      var natTxt = this.getNacionalidadTexto(t.nacionalidad);
      if (!natTxt && t.paisNacimiento) natTxt = String(t.paisNacimiento);
      // Igual que Solicitante->Generales: preferir objeto {Id,Nombre} si existe.
      this.nacionalidadConyuge = (t.nacionalidad && typeof t.nacionalidad === 'object')
        ? t.nacionalidad
        : (natTxt || '').slice(0, 50);
      this.estadoNacimientoConyuge = t.estadoNacimiento === null || t.estadoNacimiento === undefined ? '' : t.estadoNacimiento;
      this.telefonoConyuge = this.normalizeTelefonoPersonales(t.telefonoCasa);
      var cel = this.normalizeTelefonoPersonales(t.telefonoCelular);
      if (!cel) cel = this.normalizeTelefonoPersonales(t.telefonoCelular2);
      this.celularConyuge = cel;
      this.calleConyuge = this.formatoAlfanumericoCalleConyuge(t.calle || '');
      this.numeroExteriorConyuge = this.formatoAlfanumericoNumeroConyuge(t.numeroExterior || '');
      this.numeroInteriorConyuge = this.formatoAlfanumericoNumeroConyuge(t.numeroInterior || '');
      this.ciudadConyuge = (this.textFormat(t.ciudad || '')).slice(0, 50);
      this.estadoConyuge = t.estado === null || t.estado === undefined ? '' : t.estado;
      this.codigoPostalConyuge = String(t.codigoPostal || '').replace(/\D/g, '').slice(0, 5);
      this.municipioConyuge = (this.textFormat(t.municipio || '')).slice(0, 50);
      // Colonia tal cual en titular: si se “sanitiza” como calle, deja de coincidir con opciones SISEC y el select queda vacío.
      this.coloniaConyuge = t.colonia != null ? String(t.colonia) : '';
      this.domicilioConyuge = this.composeDomicilioConyugeLine();
      var selfSync = this;
      this.$nextTick(function () {
        if (selfSync.codigoPostalConyuge) {
          selfSync.getColoniaMunicipioConyuge(0);
        } else {
          selfSync.ColoniasCPConyuge = [];
        }
      });
    },
    limpiarConyugeForm(){
      // Limpia el bloque Conyugue para captura manual (switch OFF).
      this.nombreConyuge = '';
      this.segundoNombreConyuge = '';
      this.apellidoPaternoConyuge = '';
      this.apellidoMaternoConyuge = '';
      this.correoElectronicoConyuge = '';
      this.rfcConyuge = '';
      this.curpConyuge = '';
      this.fechaNacimientoConyuge = '';
      this.edadConyuge = null;
      this.nacionalidadConyuge = '';
      this.lugarNacimientoConyuge = '';
      this.sexoConyuge = '';

      this.domicilioConyuge = '';
      this.calleConyuge = '';
      this.numeroExteriorConyuge = '';
      this.numeroInteriorConyuge = '';
      this.coloniaConyuge = '';
      this.municipioConyuge = '';
      this.ciudadConyuge = '';
      this.estadoConyuge = '';
      this.codigoPostalConyuge = '';
      this.ColoniasCPConyuge = [];

      this.estadoNacimientoConyuge = '';
      this.telefonoConyuge = '';
      this.celularConyuge = '';
    },
    /**
     * Replica el mapeo de PersonalesGeneral.vue → dameSolicitante → dataSolicitante
     * (campos de Generales / Personales del solicitante titular).
     */
    mapRespuestaSolicitanteADatosTitular(s){
      const t = this.datosTitular;
      t.nombres = s.Nombres != null ? s.Nombres : '';
      t.segundoNombre = s.SegundoNombre != null ? s.SegundoNombre : '';
      t.apellidoPaterno = s.ApellidoPaterno != null ? s.ApellidoPaterno : '';
      t.apellidoMaterno = s.ApellidoMaterno != null ? s.ApellidoMaterno : '';
      var emTit = s.EMail != null ? s.EMail : (s.Email != null ? s.Email : '');
      if (emTit != null && String(emTit).trim() !== '') {
        t.correoCliente = String(emTit).trim();
      } else {
        t.correoCliente = this.solicitante || '';
      }
      t.fechaNacimiento = s.FechaNacimiento != null ? s.FechaNacimiento : '';
      if (s.Sexo === 1) t.sexo = 'H';
      else if (s.Sexo === 2) t.sexo = 'M';
      else t.sexo = '';
      t.curp = s.Curp != null ? s.Curp : '';
      t.rfc = s.Rfc != null ? s.Rfc : '';
      if (s.ScotiaNacionalidad && s.Nacionalidad) {
        t.nacionalidad = { Id: s.ScotiaNacionalidad, Nombre: s.Nacionalidad };
      } else {
        t.nacionalidad = s.Nacionalidad != null && s.Nacionalidad !== '' ? s.Nacionalidad : '';
      }
      t.estadoNacimiento = s.EstadoNacimiento == null ? '' : s.EstadoNacimiento;
      t.telefonoCasa = s.TelefonoCasa != null ? String(s.TelefonoCasa) : '';
      t.telefonoCelular = s.TelefonoCelular != null ? this.normalizeTelefonoPersonales(s.TelefonoCelular) : '';
      t.telefonoCelular2 = s.TelefonoCelular2 != null ? this.normalizeTelefonoPersonales(s.TelefonoCelular2) : '';
      t.paisNacimiento = s.PaisNacimiento != null ? s.PaisNacimiento : '';
      t.municipioNacimiento = s.MunicipioNacimiento != null ? s.MunicipioNacimiento : '';
      t.calle = s.Calle != null ? s.Calle : '';
      t.numeroExterior = s.NumeroExterior != null ? s.NumeroExterior : '';
      t.numeroInterior = s.NumeroInterior != null ? s.NumeroInterior : '';
      t.ciudad = s.Ciudad != null ? s.Ciudad : '';
      t.estado = s.Estado == null ? '' : s.Estado;
      t.codigoPostal = s.CodigoPostal != null ? s.CodigoPostal : '';
      t.municipio = s.Municipio != null ? s.Municipio : '';
      t.colonia = s.Colonia != null ? s.Colonia : '';
      t.estadoCivil = s.EstadoCivil == null || s.EstadoCivil === undefined ? '' : s.EstadoCivil;
    },
    cargarDatosTitularSolicitante(){
      if (!this.solicitante || !this.id || !this.key) {
        return;
      }
      const self = this;
      const objRequestDameSolicitante = {
        strFolioCaso: this.id,
        strApiKey: this.key,
        strMetodo: 'DameSolicitante',
        objSolicitante: {
          EMail: this.solicitante,
        },
      };
      this.$axios
        .post('/', objRequestDameSolicitante, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
        .then((response) => {
          if (response.data.intEstatus === 0) {
            self.mapRespuestaSolicitanteADatosTitular(response.data.objContenido);
            if (self.DomicilioIgual) self.aplicarDomicilioDesdeTitular();
            if (self.conyugeDomicilioIgualSolicitante) self.syncConyugeConSolicitante();
          }
        })
        .catch(function () {});
    },
    /**
     * ViveMismoDomicilioTitular: el domicilio en pantalla debe ser el del solicitante titular (Generales),
     * no el registro vacío del coacreditado en DameSolicitante.
     */
    aplicarDomicilioDesdeTitular(){
      if (!this.DomicilioIgual) return;
      const t = this.datosTitular;
      this.calle = t.calle != null ? String(t.calle) : '';
      this.numeroExterior = t.numeroExterior != null ? String(t.numeroExterior) : '';
      this.numeroInterior = t.numeroInterior != null ? String(t.numeroInterior) : '';
      this.ciudad = t.ciudad != null ? String(t.ciudad) : '';
      this.estado = t.estado !== undefined && t.estado !== null ? t.estado : '';
      this.codigoPostal = t.codigoPostal != null ? String(t.codigoPostal).replace(/\D/g, '').slice(0, 5) : '';
      this.municipio = t.municipio != null ? String(t.municipio) : '';
      this.colonia = t.colonia != null ? String(t.colonia) : '';
      var selfDom = this;
      this.$nextTick(function () {
        if (selfDom.codigoPostal) {
          selfDom.getColoniaMunicipio(0);
        }
      });
    },
    /** Comparación laxa colonia guardada vs lista SISEC (acentos / espacios). */
    normalizeColoniaCmp(s){
      return this.textFormat(String(s || '')).replace(/\s+/g, ' ').trim();
    },
    buscarColoniaEnLista(coloniaGuardada, colonias){
      if (coloniaGuardada == null || colonias == null || !colonias.length) return null;
      var g = String(coloniaGuardada).trim();
      if (g === '') return null;
      var i = colonias.indexOf(g);
      if (i !== -1) return colonias[i];
      var ng = this.normalizeColoniaCmp(g);
      for (i = 0; i < colonias.length; i++) {
        if (this.normalizeColoniaCmp(colonias[i]) === ng) return colonias[i];
      }
      return null;
    },
    formatoAlfanumericoCalleConyuge(val){
      const s = this.textFormat(String(val || ''));
      return s.replace(/[^A-Z0-9Ñ\s]/g, '').slice(0, 50);
    },
    formatoAlfanumericoNumeroConyuge(val){
      return String(val || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 10);
    },
    composeDomicilioConyugeLine(){
      const parts = [this.calleConyuge, this.numeroExteriorConyuge, this.numeroInteriorConyuge].filter(
        (p) => p != null && String(p).trim() !== ''
      );
      return parts.join(' ').trim();
    },
    /** Equivalencias switch activado: domicilio cónyuge coacreditado → snapshot local del titular */
    mirrorDomicilioConyugeEnDatosTitular(){
      var t = this.datosTitular;
      t.calle = this.calleConyuge != null ? String(this.calleConyuge) : '';
      t.numeroExterior = this.numeroExteriorConyuge != null ? String(this.numeroExteriorConyuge) : '';
      t.numeroInterior = this.numeroInteriorConyuge != null ? String(this.numeroInteriorConyuge) : '';
      t.ciudad = this.ciudadConyuge != null ? String(this.ciudadConyuge) : '';
      t.estado = this.estadoConyuge != null && this.estadoConyuge !== undefined ? this.estadoConyuge : '';
      t.codigoPostal = this.codigoPostalConyuge != null ? String(this.codigoPostalConyuge) : '';
      t.municipio = this.municipioConyuge != null ? String(this.municipioConyuge) : '';
      t.colonia = this.coloniaConyuge != null ? String(this.coloniaConyuge) : '';
    },
    /** Mantiene en memoria los datos Personales del titular tras guardar desde el bloque Conyugue (switch OFF). */
    mirrorPersonalesConyugeEnDatosTitular(){
      var t = this.datosTitular;
      t.nombres = this.nombreConyuge != null ? String(this.nombreConyuge) : '';
      t.segundoNombre = this.segundoNombreConyuge != null ? String(this.segundoNombreConyuge) : '';
      t.apellidoPaterno = this.apellidoPaternoConyuge != null ? String(this.apellidoPaternoConyuge) : '';
      t.apellidoMaterno = this.apellidoMaternoConyuge != null ? String(this.apellidoMaternoConyuge) : '';
      t.fechaNacimiento = this.fechaNacimientoConyuge != null ? String(this.fechaNacimientoConyuge) : '';
      t.sexo = this.sexoConyuge != null ? String(this.sexoConyuge) : '';
      t.curp = this.curpConyuge != null ? String(this.curpConyuge) : '';
      t.rfc = this.rfcConyuge != null ? String(this.rfcConyuge) : '';
      t.telefonoCasa = this.telefonoConyuge != null ? String(this.telefonoConyuge) : '';
      t.telefonoCelular = this.celularConyuge != null ? String(this.celularConyuge) : '';
      // Nacionalidad: mismo contrato que PersonalesGeneral (objeto {Id,Nombre} o string)
      t.nacionalidad = this.nacionalidadConyuge != null ? this.nacionalidadConyuge : '';
      t.estadoNacimiento = this.estadoNacimientoConyuge != null ? this.estadoNacimientoConyuge : '';
    },
    /**
     * Actualiza Solicitante->Personales con los datos capturados en bloque Conyugue
     * para mantener simetría de lectura/escritura sobre el mismo origen.
     */
    registraDomicilioTitularDesdeConyuge(){
      var t = this.datosTitular;
      function keepIfEmpty(nuevo, previo) {
        if (nuevo === null || nuevo === undefined) return previo != null ? previo : '';
        if (typeof nuevo === 'string' && nuevo.trim() === '') return previo != null ? previo : '';
        return nuevo;
      }
      var sexoTit = null;
      if (this.sexoConyuge === 'H') sexoTit = 1;
      else if (this.sexoConyuge === 'M') sexoTit = 2;
      else if (t.sexo === 'H') sexoTit = 1;
      else if (t.sexo === 'M') sexoTit = 2;
      var natObj = this.nacionalidadConyuge;
      var nacionalidadPayload;
      if (natObj != null && typeof natObj === 'object' && natObj.Id != null && natObj.Nombre) {
        nacionalidadPayload = { id: natObj.Id, name: natObj.Nombre, updateScotia: true };
      } else {
        nacionalidadPayload = {
          id: null,
          name: this.getNacionalidadTexto(natObj != null ? natObj : t.nacionalidad),
          updateScotia: true,
        };
      }
      var objRequest = {
        strFolioCaso: this.id,
        strApiKey: this.key,
        strMetodo: 'RegistraSolicitante',
        objSolicitante: {
          EMail: this.solicitante,
          Nombres: keepIfEmpty(this.nombreConyuge, t.nombres),
          SegundoNombre: keepIfEmpty(this.segundoNombreConyuge, t.segundoNombre),
          ApellidoPaterno: keepIfEmpty(this.apellidoPaternoConyuge, t.apellidoPaterno),
          ApellidoMaterno: keepIfEmpty(this.apellidoMaternoConyuge, t.apellidoMaterno),
          TelefonoCelular: keepIfEmpty(
            this.celularConyuge != null ? String(this.celularConyuge).replace(/\D/g, '').slice(0, 10) : '',
            t.telefonoCelular
          ),
          TelefonoCasa: keepIfEmpty(
            this.telefonoConyuge != null ? String(this.telefonoConyuge).replace(/\D/g, '').slice(0, 10) : '',
            t.telefonoCasa
          ),
          FechaNacimiento: keepIfEmpty(this.fechaNacimientoConyuge, t.fechaNacimiento),
          Rfc: keepIfEmpty(this.rfcConyuge, t.rfc),
          Curp: keepIfEmpty(this.curpConyuge, t.curp),
          Sexo: sexoTit,
          Calle: keepIfEmpty(this.calleConyuge, t.calle),
          NumeroExterior: keepIfEmpty(this.numeroExteriorConyuge, t.numeroExterior),
          NumeroInterior: keepIfEmpty(this.numeroInteriorConyuge, t.numeroInterior),
          Colonia: keepIfEmpty(this.coloniaConyuge, t.colonia),
          Municipio: keepIfEmpty(this.municipioConyuge, t.municipio),
          Ciudad: keepIfEmpty(this.ciudadConyuge, t.ciudad),
          Estado: keepIfEmpty(this.estadoConyuge, t.estado),
          CodigoPostal: keepIfEmpty(this.codigoPostalConyuge, t.codigoPostal),
          Nacionalidad: nacionalidadPayload,
          EstadoNacimiento: this.estadoNacimientoConyuge != null ? this.estadoNacimientoConyuge : t.estadoNacimiento,
          EstadoCivil: t.estadoCivil,
        },
      };
      return this.$axios.post('/', objRequest, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      });
    },
    registraConyugeObligadoEnSolicitanteTitular(){
      var objRequest = {
        strFolioCaso: this.id,
        strApiKey: this.key,
        strMetodo: 'RegistraSolicitante',
        objSolicitante: {
          EMail: this.solicitante,
          NombreConyugeObligado: this.composeNombreConyuge(),
          ApellidoPaternoConyugeObligado: this.apellidoPaternoConyuge,
          ApellidoMaternoConyugeObligado: this.apellidoMaternoConyuge,
          RFCConyugeObligado: this.rfcConyuge,
          CURPConyugeObligado: this.curpConyuge,
          FechaNacimientoConyugeObligado: this.fechaNacimientoConyuge,
          EdadConyugeObligado: this.edadConyuge,
          NacionalidadConyugeObligado: this.nacionalidadConyuge
            ? {
                id: this.nacionalidadConyuge.Id != null ? this.nacionalidadConyuge.Id : null,
                name: this.nacionalidadConyuge.Nombre != null ? this.nacionalidadConyuge.Nombre : String(this.nacionalidadConyuge),
                updateScotia: true,
              }
            : {
                id: null,
                name: '',
                updateScotia: true,
              },
          LugarNacimientoConyugeObligado: this.lugarNacimientoConyuge,
          SexoConyugeObligado: this.sexoConyuge,
          DomicilioConyugeObligado: this.domicilioConyuge,
          ColoniaConyugeObligado: this.coloniaConyuge,
          MunicipioConyugeObligado: this.municipioConyuge,
          CodigoPostalConyugeObligado: this.codigoPostalConyuge,
        },
      };
      return this.$axios.post('/', objRequest, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      });
    },
    getAños(){
      let current=new Date().getFullYear()
      for (var i = 0; i < 31; i++) {
        this.años.push({ Nombre: current-i,  Id: current-i })
      }
    },
    getGradosEstudio(){
      let self=this
      var objRequestListaEscolaridades = {
        strApiKey: this.key,
        strMetodo: 'ListaEscolaridades',
      }
      this.$axios.post('/',objRequestListaEscolaridades,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            this.gradosEstudio=response.data.objContenido
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en ListaEscolaridades',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    getIdentificaciones(){
      let self=this
      var objRequestListaTipoIdentificaciones = {
        strApiKey: this.key,
        strMetodo: 'ListaTipoIdentificaciones',
      }
      this.$axios.post('/',objRequestListaTipoIdentificaciones,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            let identificacionList = response.data.objContenido;
            identificacionList = identificacionList.filter(identi => identi.Id != 7);
            this.identificaciones = identificacionList;

            // 2023-05-04 Mejora en identificacion
            // this.identificaciones=response.data.objContenido
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en ListaTipoIdentificaciones',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    getListaDomicilioOcupaciones(){
      let self=this
      var objRequestListaDomicilioOcupaciones = {
        strApiKey: this.key,
        strMetodo: 'ListaDomicilioOcupaciones',
      }
      this.$axios.post('/',objRequestListaDomicilioOcupaciones,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            this.domicilioOcupaciones=response.data.objContenido
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en ListaDomicilioOcupaciones',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    getPaisesNacimiento() {
			this.paisesNac = paisesNacimiento;
		},
    async getAuthToken() {
      let objRequestToken = {
        strApiKey: this.key,
        strMetodo: 'DameAuthToken',
      }
      await this.$axios.post('/', objRequestToken,
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
        .then( response => {
          if (!response.data.error) {
            this.tokenSisec = "Bearer "+ response.data.access_token;
          } else {
            this.$vs.notify({
              title: 'Ocurrio un error al obtener token',
              text: response.data.error_description,
              color: 'danger',
              position: 'top-right',
            })
          }
        }).catch(function (error) {
          self.$vs.notify({
            title: 'Ocurrio un error de sistema',
            text: error,
            color: 'danger',
            position: 'top-right',
          })
        });
    },
		getNacionalidades() {
			let nacionalidadesList = [];
			let index = 3;
			for (const nacionalidad of nacionalidades) {
				if (nacionalidad.Nombre === "MEXICANO (A)") {
					nacionalidadesList[0] = nacionalidad;
					continue;
				}
				if (nacionalidad.Nombre === "NORTEAMERICANO (A)") {
					nacionalidadesList[1] = nacionalidad;
					continue;
				}
				if (nacionalidad.Nombre === "CANADIENSE") {
					nacionalidadesList[2] = nacionalidad;
					continue;
				}
				nacionalidadesList[index] = nacionalidad;
				index ++;
			}
			this.nacionalidades = nacionalidadesList;
		},
    eliminarCoacreditado(){
      var eliminarCoacreditado = {
        strApiKey:this.key,
        strMetodo:'BorrarCoacreditado',
        objCaso:{
            Id:this.id
          }
      }
      this.$axios.post('/',eliminarCoacreditado,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            this.$vs.notify({
              title:`Se eliminó exitosamente`,
              position:'top-right'
            })
            this.email=''
            if (this.AccreditedidV3) { //si el solicitante cuenta con pedidos en v3 entonces actualiza inf en liga cliente.
              this.generaInformacionParaV3(); 
            }

						this.$emit('changeCoacreditado', false)
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en BorrarCoacreditado',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    generaInformacionParaV3(){
			let self=this
        var objRequestDameInfo = {
          strFolioCaso: this.id,
          strApiKey: this.key,
          strMetodo: 'generaInformacionParaV3',
          objSolicitante:
          {
              EMail: this.solicitante
          },
          objCaso: {
          Id: this.Id,
          }
        }
        this.$axios.post('/',objRequestDameInfo,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
        .then(
          response => {
            if(response.data.intEstatus == 0){
              this.solicitanteV3 = response.data.objContenido
              this.updateInfoEnV3()
            }else {
              this.$vs.notify({
                title:'Ocurrio un error en generaInformacionParaV3',
                text:response.data.strError,
                color:'danger',
                position:'top-right'
              })
            }
          }
        ).catch(function (error) {
          self.$vs.notify({
            title:'Ocurrio un error de sistema',
            text:error,
            color:'danger',
            position:'top-right'
          })
        })
		},
    async updateInfoEnV3(){
      await this.getAuthToken();

			let self=this
				
			var mostrar = ""
			let objRequestUpdateInfo =
			{
			IsQuickQuote:false,
			AccreditedModel: {
				Name: this.solicitanteV3.Nombres,
				SName: this.solicitanteV3.SegundoNombre,
				LastName: this.solicitanteV3.ApellidoPaterno,
				SecondLastName: this.solicitanteV3.ApellidoMaterno,
				PersonalMail: this.solicitante,
				PhoneHome: this.solicitanteV3.TelefonoCasa,
				CellPhone: this.solicitanteV3.TelefonoCelular,
				DateBirtday: this.solicitanteV3.FechaNacimiento,
				Gender: this.solicitanteV3.Genero,
				Nationality: this.solicitanteV3.Nacionalidad,
				CURP: this.solicitanteV3.CURP,
				RFC: this.solicitanteV3.RFC,
				Weight: this.solicitanteV3.Peso,
				Height: this.solicitanteV3.Estatura,
				NSS: this.solicitanteV3.Nss,
				StudyGrade: this.solicitanteV3.GradoEstudios,
				CivilStatus: this.solicitanteV3.EstadoCivil,
				EconomicDependents: this.solicitanteV3.DependientesEconomicos,
				NumberOfChildren: this.solicitanteV3.NumeroHijos,
				ChildrensAge: this.solicitanteV3.EdadHijos,
				Cocredited: this.solicitanteV3.Coacreditado,
				//domicilio
				TypeHousing: this.solicitanteV3.TipoInmueble,
				ResidenceTimeHome: this.solicitanteV3.TiempoResidenciaActual,
				ResidenceTimeTown: this.solicitanteV3.TiempoResidenciaPoblacion,
				CP: this.solicitanteV3.CodigoPostal,
				//Bienes inmuebles
				NumberOfCars: this.solicitanteV3.NumeroAutos,				
				//Ingresos
				Activity: this.solicitanteV3.Sector,
				TypeCompany: this.solicitanteV3.TipoEmpleo,
				CompanyName: this.solicitanteV3.Empresa,
				CompanyAddress: this.solicitanteV3.DomicilioEmpresa,
				MonetaryIncome: this.solicitanteV3.Ingresos,
				Position: this.solicitanteV3.Puesto,
				DateBeginWork: this.solicitanteV3.FechaInicio,

				Age: this.solicitanteV3.Edad,		
			},
			ReferencesModel: [
        {
          Name: this.solicitanteV3.NombreReferencia,
          SName: null,
          LastName: this.solicitanteV3.ApellidoPaternoRef,
          SecondLastName: this.solicitanteV3.ApellidoMaternoRef,
          Phone: this.solicitanteV3.TelCelularRef,
          Relationship: this.solicitanteV3.ParentescoRef,
          TimeRelationship: this.solicitanteV3.AnosConocerloRef
        }
      ],
			CreditRequestModel: {
				TypeCredit: null,
				HomeValue: null,
				CreditAmount: null,
				Plazo: null
			},
			BrokerEmployeeModel: {
        Id: this.SocGuid,
        BrokerId: this.BrokerId,
          //para pruebas comentar las dos de arriba, terminando descomentar arriba y commentar abajo
          //Id: "61711b5c-948c-4928-94f0-158b96b58da0",
          //BrokerId:"ca1b7cbd-f2a5-4507-9f03-4c167dcb2663",
				EmployeeName: null,
				EmployeeEmail: null,
				Origin: "Cotizador soc"
				
			},
			MaterialGoodsModel:{
				Properties:{
					NumberProperties: this.solicitanteV3.NumeroInmuebles,
					ApproximateValue: this.solicitanteV3.ValorAproximado,
					EncumberedValue: this.solicitanteV3.ValorGrabado,
				},
				CarOne:{
					ApproximateValueCar: this.solicitanteV3.ValorAuto1,
					MarkCar: this.solicitanteV3.MarcaAuto1,
					ModelCar: this.solicitanteV3.ModeloAuto1,
					YearCar: this.solicitanteV3.AnioAuto1,
				},
				CarTwo:{
					ApproximateValueCar: this.solicitanteV3.ValorAuto2,
					MarkCar: this.solicitanteV3.MarcaAuto2,
					ModelCar: this.solicitanteV3.ModeloAuto2,
					YearCar: this.solicitanteV3.AnioAuto2
				}
			}

			
			}   
			this.$axios.post('https://preprodapivalidacionriesgos.sisec.mxapi/External/CreateAccredited',objRequestUpdateInfo,{headers : {"Authorization": this.tokenSisec}})
				.then(
				response => {

				}
				).catch(function (error) {
					if(error.response.data.Message == "The CellPhone already exists"){
					mostrar = "El telefono ya se encuentra registrado intente con otro"
					}else if(error.response.data.Message == "The email already exists"){
					mostrar = "El correo elecronico ya se encuentra registrado intente con otro"
					}else{
					mostrar = error
					}
					
					self.$vs.notify({
						title:'Ocurrio un error en SISEC',
						text:mostrar,
						color:'danger',
						position:'top-right'
					})
				})

		},
    DameCredenciales(){
        let self=this
        let objRequestDameCredenciales = {
          strApiKey: this.key,
          strMetodo: 'DameCredenciales',
          objBroker: {
          ApiKey: this.key
          }
        }
        this.$axios.post('/',objRequestDameCredenciales,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
        .then(
          response => {
          this.SocGuid = response.data.objContenido.SocGuid
          this.BrokerId = response.data.objContenido.BrokerId

          //this.SocGuid = '61711b5c-948c-4928-94f0-158b96b58da0',
          //this.BrokerId = 'ca1b7cbd-f2a5-4507-9f03-4c167dcb2663';

          }
        ).catch(function (error) {
          self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
          })
        })
    },
    actualizarInfo(){
       this.$vs.loading({
				container: '#cotizacion',
				scale: 0.6,
	     })
      // Con switch "Solicitante", prioriza datos directos del titular y evita enviar valores viejos del bloque *ConyugeObligado.
      if (this.conyugeDomicilioIgualSolicitante && this.datosTitular && this.datosTitular.nombres) {
        this.syncConyugeConSolicitante();
      }
      var tieneCalleGranularConyuge = [this.calleConyuge, this.numeroExteriorConyuge, this.numeroInteriorConyuge].some(function (p) {
        return p != null && String(p).trim() !== '';
      });
      if (!tieneCalleGranularConyuge && this.domicilioConyuge != null && String(this.domicilioConyuge).trim() !== '') {
        this.calleConyuge = this.formatoAlfanumericoCalleConyuge(this.domicilioConyuge);
      }
      this.domicilioConyuge = this.composeDomicilioConyugeLine();
      let self= this
      let sexo
      if(this.sexo== 'H'){
        sexo=1
      }else{
        sexo=2
      }
      // Si vive en el mismo domicilio que el titular, el formulario vacía la calle del coacreditado
      // pero el API sigue validando Calle como obligatoria: enviar domicilio del solicitante (datosTitular).
      var tDom = this.datosTitular;
      var mismoDomTitular = this.DomicilioIgual;
      var envioCalle = mismoDomTitular ? (tDom.calle != null ? tDom.calle : '') : this.calle;
      var envioNumExt = mismoDomTitular ? (tDom.numeroExterior != null ? tDom.numeroExterior : '') : this.numeroExterior;
      var envioNumInt = mismoDomTitular ? (tDom.numeroInterior != null ? tDom.numeroInterior : '') : this.numeroInterior;
      var envioColonia = mismoDomTitular ? (tDom.colonia != null ? tDom.colonia : '') : this.colonia;
      var envioMunicipio = mismoDomTitular ? (tDom.municipio != null ? tDom.municipio : '') : this.municipio;
      var envioCiudad = mismoDomTitular ? (tDom.ciudad != null ? tDom.ciudad : '') : this.ciudad;
      var envioEstado = mismoDomTitular ? (tDom.estado != null ? tDom.estado : '') : this.estado;
      var envioCP = mismoDomTitular ? (tDom.codigoPostal != null ? tDom.codigoPostal : '') : this.codigoPostal;
      var nombresPrincipal = this.nombre != null ? String(this.nombre).trim() : '';
      var apPatPrincipal = this.apellidoPaterno != null ? String(this.apellidoPaterno).trim() : '';
      var apMatPrincipal = this.apellidoMaterno != null ? String(this.apellidoMaterno).trim() : '';
      var conyugeVaACoacreditado = this.conyugeDomicilioIgualSolicitante === true;
      var nombreConyugeObligadoPayload = conyugeVaACoacreditado ? this.composeNombreConyuge() : ' ';
      var apPatConyugeObligadoPayload = conyugeVaACoacreditado ? this.apellidoPaternoConyuge : '';
      var apMatConyugeObligadoPayload = conyugeVaACoacreditado ? this.apellidoMaternoConyuge : '';

      let objRequestRegistraSolicitante = {
        strFolioCaso: this.id,
        strApiKey: this.key,
        strMetodo: 'RegistraSolicitante',
        objSolicitante: {
          EMail: this.email,
          Nombres: nombresPrincipal,
          ApellidoPaterno: apPatPrincipal,
          ApellidoMaterno: apMatPrincipal,
          TelefonoCelular: this.telefono,
          FechaNacimiento: this.fechaNacimiento,
          Rfc: this.rfc,
          Curp: this.curp,
      		Sexo:sexo,
      		Calle: envioCalle,
      		NumeroExterior: envioNumExt,
          NumeroInterior: envioNumInt,
      		Colonia: envioColonia,
      		Municipio: envioMunicipio,
      		Ciudad: envioCiudad,
      		Estado: envioEstado,
      		CodigoPostal: envioCP,
          // Nacionalidad:this.nacionalidad,
					Nacionalidad: {
						id: this.nacionalidad.Id,
						name: this.nacionalidad.Nombre,
						updateScotia: true,
					},

          EstadoCivil:this.estadoCivil,
          ViveMismoDomicilioTitular : this.DomicilioIgual,
          ConyugeDesdeSolicitanteTitular: this.conyugeDomicilioIgualSolicitante === true
        }
      }
      if (conyugeVaACoacreditado) {
        objRequestRegistraSolicitante.objSolicitante.NombreConyugeObligado = nombreConyugeObligadoPayload;
        objRequestRegistraSolicitante.objSolicitante.ApellidoPaternoConyugeObligado = apPatConyugeObligadoPayload;
        objRequestRegistraSolicitante.objSolicitante.ApellidoMaternoConyugeObligado = apMatConyugeObligadoPayload;
        objRequestRegistraSolicitante.objSolicitante.RFCConyugeObligado = this.rfcConyuge;
        objRequestRegistraSolicitante.objSolicitante.CURPConyugeObligado = this.curpConyuge;
        objRequestRegistraSolicitante.objSolicitante.FechaNacimientoConyugeObligado = this.fechaNacimientoConyuge;
        objRequestRegistraSolicitante.objSolicitante.EdadConyugeObligado = this.edadConyuge;
        objRequestRegistraSolicitante.objSolicitante.NacionalidadConyugeObligado = this.nacionalidadConyuge
          ? {
              id: this.nacionalidadConyuge.Id != null ? this.nacionalidadConyuge.Id : null,
              name: this.nacionalidadConyuge.Nombre != null ? this.nacionalidadConyuge.Nombre : String(this.nacionalidadConyuge),
              updateScotia: true,
            }
          : {
              id: null,
              name: '',
              updateScotia: true,
            };
        objRequestRegistraSolicitante.objSolicitante.LugarNacimientoConyugeObligado = this.lugarNacimientoConyuge;
        objRequestRegistraSolicitante.objSolicitante.SexoConyugeObligado = this.sexoConyuge;
        objRequestRegistraSolicitante.objSolicitante.DomicilioConyugeObligado = this.domicilioConyuge;
        objRequestRegistraSolicitante.objSolicitante.ColoniaConyugeObligado = this.coloniaConyuge;
        objRequestRegistraSolicitante.objSolicitante.MunicipioConyugeObligado = this.municipioConyuge;
        objRequestRegistraSolicitante.objSolicitante.CodigoPostalConyugeObligado = this.codigoPostalConyuge;
      }
      this.$axios.post('/',objRequestRegistraSolicitante,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            this.$vs.notify({
              title:`Datos guardados exitosamente`,
              position:'top-right'
            })
            var selfVue = this;
            function finGuardadoCoacreditado() {
              selfVue.$vs.loading.close('#cotizacion > .con-vs-loading');
              selfVue.registraAdicionales();
            }
            if (!this.conyugeDomicilioIgualSolicitante && this.solicitante) {
              this.registraDomicilioTitularDesdeConyuge()
                .then(function (r2) {
                  if (r2.data && r2.data.intEstatus === 0) {
                    selfVue.mirrorDomicilioConyugeEnDatosTitular();
                    selfVue.mirrorPersonalesConyugeEnDatosTitular();
                  } else {
                    selfVue.$vs.notify({
                      title: 'Guardado de conyugue en solicitante',
                      text: (r2.data && r2.data.strError) ? r2.data.strError : 'No se pudo guardar el bloque Conyugue en Solicitante.',
                      color: 'warning',
                      position: 'top-right',
                    });
                  }
                  finGuardadoCoacreditado();
                })
                .catch(function (err) {
                  selfVue.$vs.notify({
                    title: 'Error al guardar conyugue en solicitante',
                    text: String(err),
                    color: 'danger',
                    position: 'top-right',
                  });
                  finGuardadoCoacreditado();
                });
            } else {
              finGuardadoCoacreditado();
            }
          }else {
            this.$vs.loading.close('#cotizacion > .con-vs-loading')
            this.$vs.notify({
              title:'Ocurrio un error en RegistraSolicitante',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }

      ).catch(function (error) {
        self.$vs.loading.close('#cotizacion > .con-vs-loading')
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    registraAdicionales(){
      var auto1Valor = '';
      var auto2Valor = '';
      
      if (!this.adicionales.autosPropios) {
          this.adicionales.autosPropios = null;
          this.adicionales.vehiculos.numero = null;
          this.adicionales.vehiculos.valor = '';
          this.adicionales.vehiculos.marca = null;
          this.adicionales.vehiculos.modelo = null;
          this.adicionales.vehiculos.anio = null;

          this.adicionales.vehiculos.pago = null;
          this.adicionales.vehiculos.valor2 = '';
          this.adicionales.vehiculos.marca2 = null;
          this.adicionales.vehiculos.modelo2 = null;
          this.adicionales.vehiculos.anio2 = null;
          this.adicionales.vehiculos.pago2 = null;
      }
      else{
        auto1Valor = parseFloat(this.adicionales.vehiculos.valor.replace(/,/g,""));
        auto2Valor = parseFloat(this.adicionales.vehiculos.valor2.replace(/,/g,""));
      }

      let self=this
      var objRequestAdicionales = {
        strFolioCaso: this.id,
        strApiKey: this.key,
        strMetodo: 'RegistraCoacreditadoAdicionales',
        objSolicitante: {
        EMail:this.email,
        Personales:{
          CompaniaCelular:this.adicionales.companiaCelular,
          IdentificacionPresenta:this.adicionales.identificacionPresenta,
          NumeroIdentificacion:this.adicionales.numeroIfe,
          Nss:this.adicionales.nss,
          Issste: this.adicionales.issste,
          Fiel:this.adicionales.fiel,
          TelefonoFijo:this.adicionales.telefonoFijo,
          TelefonoOficina:this.adicionales.telefonoOficina,
          VigenciaIdentificacion:this.adicionales.vigencia,
          TitularidadDomicilio:this.adicionales.titularidadDomicilio,
          ParticipaCredito:this.adicionales.participaCreditoInfonavit,
          CalleExtranjero:this.adicionales.calleExtranjero,
          NumeroExteriorExtranjero:this.adicionales.numeroExteriorExtranjero,
          NumeroInteriorExtranjero:this.adicionales.numeroInteriorExtranjero,
          ColoniaExtranjero:this.adicionales.coloniaExtranjero,
          EstadoExtranjero:this.adicionales.estadoExtranjero,
          // PaisExtranjero:this.adicionales.paisExtranjero,
          PaisExtranjero: {
            name: this.adicionales.paisExtranjero,
            noSanitiza: true,
          },
          CodigoPostalExtranjero:this.adicionales.codigoPostalExtranjero,
          PaisRecidencia:this.adicionales.PaisRecidencia
        },
        Estudios:{
          GradoEstudios:this.adicionales.gradoEstudios,
          InstitucionEstudios : this.adicionales.institucionEstudios,
        },        
        Nacionalidad:{
          OtroNombre:this.adicionales.otroNombre,
          EstadoNacimiento:this.adicionales.estadoNacimiento,
          MunicipioNacimiento:this.adicionales.municipioNacimiento,
          // PaisNacimiento:this.adicionales.paisNacimiento,
          PaisNacimiento: {
            name: this.adicionales.paisNacimiento,
            noSanitiza: true,
          },
        },
        DomicilioActual:{
          TiempoOcupandoDomicilioActual:this.adicionales.tiempoOcupandoDomicilioActual,
          //AntiguedadDomicilioAnterior:this.adicionales.antiguedadDomicilioAnterior,
          AntiguedadCiudad:this.adicionales.antiguedadCiudad,
          AntiguedadEnCiudadMeses: this.adicionales.antiguedadCiudadMeses,

          TiempoViviendoCiudadMeses: this.adicionales.tiempoOcupandoDomicilioActualMeses,
        },
        Propiedades:{
          VehiculosPropios:this.adicionales.autosPropios,
          NumeroVehiculos:this.adicionales.vehiculos.numero,
          Auto1Valor:auto1Valor,
          Auto1Marca:this.adicionales.vehiculos.marca,
          Auto1Modelo:this.adicionales.vehiculos.modelo,
          Auto1Anio:this.adicionales.vehiculos.anio,

          Auto1Pago:this.adicionales.vehiculos.pago,
          Auto2Valor:auto2Valor,
          Auto2Marca:this.adicionales.vehiculos.marca2,
          Auto2Modelo:this.adicionales.vehiculos.modelo2,
          Auto2Anio:this.adicionales.vehiculos.anio2,
          Auto2Pago:this.adicionales.vehiculos.pago2,
        },
      }
    }
      this.$axios.post('/',objRequestAdicionales,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            this.$vs.notify({
              title:`Guardado exitosamente`,
              position:'top-right'
            }) 
            this.dameSolicitante()                     
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en RegistraAdicionalesSolicitud',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    dameCaso(){
      let self= this
      var objRequestDameCaso = {
        strApiKey: this.key,
        strMetodo: 'DameCaso',
        objCaso: {
         Id: this.id
        }
      }
      this.$axios.post('/',objRequestDameCaso,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            //console.log(response.data.objContenido)
            if (response.data.objContenido.Coacreditado[0]) {
              this.email= response.data.objContenido.Coacreditado[0].EMail
              this.solicitante=response.data.objContenido.Solicitante
              this.parentesco=response.data.objContenido.Coacreditado[0].Parentesco
              this.Id = response.data.objContenido.Id
              this.dameSolicitante()
            }
           //  alert(this.parentesco)
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en DameCaso',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    dameSolicitante(){
      let self= this
      var objRequestDameSolicitante = {
        strFolioCaso: this.id,
        strApiKey: this.key,
        strMetodo: 'DameSolicitante',
        objSolicitante: {
      	 EMail: this.email
        }
      }
      this.$axios.post('/',objRequestDameSolicitante,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            let solicitante =response.data.objContenido
            this.nombre= solicitante.Nombres
            this.apellidoPaterno= solicitante.ApellidoPaterno
            this.apellidoMaterno= solicitante.ApellidoMaterno
            this.telefono= solicitante.TelefonoCelular
            this.fechaNacimiento= solicitante.FechaNacimiento
            this.rfc=solicitante.Rfc
            if(solicitante.Sexo== 1){
              this.sexo='H'
            }else if (solicitante.Sexo== 2) {
              this.sexo='M'
            }
            this.calle = solicitante.Calle
            this.numeroExterior = solicitante.NumeroExterior
            this.numeroInterior = solicitante.NumeroInterior
            this.colonia = solicitante.Colonia
            this.ciudad = solicitante.Ciudad
            this.municipio = solicitante.Municipio
            this.curp = solicitante.Curp
            this.codigoPostal = solicitante.CodigoPostal
            this.DomicilioIgual = solicitante.ViveMismoDomicilioTitular  // ticket #85059
            var cst = solicitante.ConyugeDesdeSolicitanteTitular;
            this.conyugeDomicilioIgualSolicitante = cst === true || cst === 1 || cst === '1';
            //ADICIONALES
            this.adicionales.telefonoOficina=solicitante.TelefonoOficina
            this.adicionales.telefonoFijo=solicitante.TelefonoCasa   
            this.adicionales.municipioNacimiento=solicitante.MunicipioNacimiento
            this.adicionales.paisNacimiento=solicitante.PaisNacimiento        
            if(solicitante.EstadoNacimiento==null)
              this.adicionales.estadoNacimiento= ''
            else
              this.adicionales.estadoNacimiento=solicitante.EstadoNacimiento 
            
            if(solicitante.TipoOcupacion==null)
              this.adicionales.titularidadDomicilio= ''
            else
              this.adicionales.titularidadDomicilio= solicitante.TipoOcupacion

            this.adicionales.tiempoOcupandoDomicilioActual= solicitante.TiempoViviendoCiudad
            this.adicionales.tiempoOcupandoDomicilioActualMeses = solicitante.TiempoViviendoCiudadMeses ? solicitante.TiempoViviendoCiudadMeses : 0;
            this.adicionales.antiguedadCiudad= solicitante.AntiguedadEnCiudad ?  solicitante.AntiguedadEnCiudad : 0;
            this.adicionales.antiguedadCiudadMeses= solicitante.AntiguedadEnCiudadMeses ?  solicitante.AntiguedadEnCiudadMeses : 0;
            this.adicionales.antiguedadDomicilioAnterior = solicitante.AntiguedadDomicilioAnterior

            if(solicitante.Identificacion==null)
              this.adicionales.identificacionPresenta= ''
            else  
              this.adicionales.identificacionPresenta= solicitante.Identificacion

            this.adicionales.numeroIfe = solicitante.NumeroIdentificacion
            this.adicionales.vigencia = solicitante.VigenciaIdentificacion
            this.adicionales.companiaCelular = solicitante.CompaniaCelular
            this.adicionales.nss = solicitante.Nss
            this.adicionales.fiel = solicitante.Fiel
            this.adicionales.issste= solicitante.Issste

            if(solicitante.Escolaridad == null)
              this.adicionales.gradoEstudios= ''
            else 
              this.adicionales.gradoEstudios = solicitante.Escolaridad

            this.adicionales.institucionEstudios = solicitante.EscolaridadInstitucion
            this.adicionales.otroNombre = solicitante.OtroNombreAnterior

            // DOMICILIO DE CIUDADANO EN EXTRAJERO
            this.adicionales.calleExtranjero = solicitante.CalleExtranjero
            this.adicionales.numeroExteriorExtranjero=   solicitante.NumeroExteriorExtranjero
            this.adicionales.numeroInteriorExtranjero=   solicitante.NumeroInteriorExtranjero
            this.adicionales.coloniaExtranjero=   solicitante.ColoniaExtranjero
            this.adicionales.estadoExtranjero = solicitante.EstadoExtranjero
            this.adicionales.paisExtranjero = solicitante.PaisExtranjero
            this.adicionales.codigoPostalExtranjero = solicitante.CodigoPostalExtranjero

            // AUTOS PROPIOS
            this.adicionales.participaCreditoInfonavit = solicitante.ParticipaInfovIssste
            this.adicionales.autosPropios = solicitante.AutosPropios
            this.adicionales.vehiculos.numero=solicitante.AutosPropiosNumero
            this.adicionales.vehiculos.marca=solicitante.AutosPropiosMarca
            this.adicionales.vehiculos.modelo=solicitante.AutosPropiosModelo
            if(solicitante.AutosPropiosAno==null)
              this.adicionales.vehiculos.anio= ''
            else
              this.adicionales.vehiculos.anio=solicitante.AutosPropiosAno

            this.adicionales.vehiculos.pago=solicitante.AutosPropiosPago

            this.adicionales.vehiculos.marca2=solicitante.AutosPropios2Marca
            this.adicionales.vehiculos.modelo2=solicitante.AutosPropios2Modelo
            if(solicitante.AutosPropios2Ano==null)
              this.adicionales.vehiculos.anio2= ''
            else
            this.adicionales.vehiculos.anio2=solicitante.AutosPropios2Ano

            this.adicionales.vehiculos.pago2=solicitante.AutosPropios2Pago
            if (solicitante.AutosPropiosValor) {
              this.adicionales.vehiculos.valor=(solicitante.AutosPropiosValor).toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            if (solicitante.AutosPropios2Valor) {
              this.adicionales.vehiculos.valor2=(solicitante.AutosPropios2Valor).toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }

            if (solicitante.CodigoPostal != '' || solicitante.CodigoPostal != null) {
              this.getColoniaMunicipio(0)
            }

            if(solicitante.Estado==null)
              this.estado=''
            else
              this.estado=solicitante.Estado

            if(solicitante.EstadoCivil==null)
              this.estadoCivil=''
            else
              this.estadoCivil=solicitante.EstadoCivil   

            // this.nacionalidad=solicitante.Nacionalidad
            if (solicitante.ScotiaNacionalidad && solicitante.Nacionalidad) {
              this.nacionalidad = {
                Id: solicitante.ScotiaNacionalidad,
                Nombre: solicitante.Nacionalidad,
              };
            } else {
              this.nacionalidad = '';
            }

            this.dameConyuge()

            // Regla de carga: si el switch "Solicitante" está OFF, el bloque Conyugue debe iniciar limpio
            // para captura manual (no hidratar desde *ConyugeObligado ni desde titular).
            if (!this.conyugeDomicilioIgualSolicitante) {
              this.limpiarConyugeForm();
            }
           this.cargarDatosTitularSolicitante();

           this.dameSolicitantePrincipal();
           
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en DameSolicitante',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    dameSolicitantePrincipal(){
      
			let self = this
			var objRequestDameSolicitante = {
        strFolioCaso: this.id,
				strApiKey: this.key,
				strMetodo: 'DameSolicitante',
				objSolicitante: {
					EMail: this.solicitante,
				},
			}
			this.$axios
				.post('/', objRequestDameSolicitante, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
				.then((response) => {

					const status = response.data.intEstatus
					const dataSolicitante = response.data.objContenido

          if (dataSolicitante.AccreditedIdV3 !=null && dataSolicitante.AccreditedIdV3 != '') {
            this.AccreditedidV3 = true;
          }

          if ( status ) {

						this.$vs.notify({
              title:'Ocurrio un error en DameSolicitante',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })

					}		  
				})
				.catch(function (error) {
					self.$vs.notify({
						title: 'Ocurrio un error de sistema',
						text: error,
						color: 'danger',
						position: 'top-right',
					})
				})
		},
    getApikey(){
      if(!JSON.parse(localStorage.getItem('userInfo')).ApiKey){
        this.$router.push('/login');
      }else {
        this.key=JSON.parse(localStorage.getItem('userInfo')).ApiKey;
      }
    },
    getEstadosCiviles(){
      let self= this
      var objRequestListaEstadosCiviles = {
        strApiKey: this.key,
        strMetodo: 'ListaEstadosCiviles',
      }
      this.$axios.post('/',objRequestListaEstadosCiviles,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            this.estadosCiviles=response.data.objContenido
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en ListaEstadosCiviles',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    getEstados(){
      let self= this
      var objRequestListaCasoEstatus = {
        strApiKey: this.key,
        strMetodo: 'ListaEstados',
      }
      this.$axios.post('/',objRequestListaCasoEstatus,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            this.estados=response.data.objContenido
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en ListaEstados',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    getStateName(id){
      return this.states[id-1]
    },
    getListaParentescos(){
      let self= this
      var objRequestListaCasoEstatus = {
        strApiKey: this.key,
        strMetodo: 'ListaParentescos',
      }
      this.$axios.post('/',objRequestListaCasoEstatus,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            this.parentescos=response.data.objContenido
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en ListaParentescos',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    dameConyuge(){
       let self= this
      var objRequestDameConyuge = {
        strFolioCaso: this.id,
        strApiKey: this.key,
        strMetodo: 'DameConyuge',
        objSolicitante:
        { EMailSolicitante:this.solicitante, 
          EMail:this.email
        }
      }
      this.$axios.post('/',objRequestDameConyuge,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            this.conyugeIsCoacred=response.data.objContenido
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en DameConyuge',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    dameDireccion(){
      let self= this
      var objRequestDameSolicitante = {
        strFolioCaso: this.id,
        strApiKey: this.key,
        strMetodo: 'DameSolicitante',
        objSolicitante: {
      	 EMail: this.solicitante
        }
      }
      this.$axios.post('/',objRequestDameSolicitante,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            let solicitante =response.data.objContenido
            this.calle = solicitante.Calle
            this.numeroExterior = solicitante.NumeroExterior
            this.numeroInterior = solicitante.NumeroInterior
            this.colonia = solicitante.Colonia
            this.ciudad = solicitante.Ciudad
            this.municipio = solicitante.Municipio
            this.codigoPostal = solicitante.CodigoPostal
            if (solicitante.CodigoPostal) {
              this.getColoniaMunicipio(0);
            }
            this.estado = solicitante.Estado
            //this.DomicilioIgual = true          

          }else {
            this.$vs.notify({
              title:'Ocurrio un error en DameSolicitante',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },    
    asgnaDomicilio(){            
      //console.log(this.conyugeIsCoacred)
      if(!this.DomicilioIgual){
          this.dameDireccion()
        }else{                                  
            this.calle = ""
            this.numeroExterior = ""
            this.numeroInterior = ""
            this.colonia = ""
            this.ciudad = ""
            this.municipio = ""
            this.codigoPostal = ""
            this.estado = ""                   
        }
		},
    async getColoniaMunicipio(value){
      var origen = 0;

      if (value == 1) {
				this.colonia = '';	
        origen = 1;
			}

        const getToken = await this.getTokenSisec();
        var token = getToken.objRespuesta.token
        const dataInfoCP = await this.getInformationCP(token, this.codigoPostal)

        if ( !dataInfoCP ) {
          this.colonia = ''
          this.municipio = ''
          return
        }
        
        const colonias = dataInfoCP.map(x => x.colonia)
        this.ColoniasCP = colonias
        this.municipio = dataInfoCP[0].municipio

        if (origen == 0) {
          var matchedCol = this.buscarColoniaEnLista(this.colonia, colonias);
          if (matchedCol) {
            this.colonia = matchedCol;
          } else if (this.colonia && String(this.colonia).trim() !== '') {
            this.ColoniasCP = [this.colonia].concat(colonias);
          }
        }
		
		},
    async getColoniaMunicipioConyuge(value){
      var origen = 0;
      if (value == 1) {
        this.coloniaConyuge = '';
        origen = 1;
      }
      const getToken = await this.getTokenSisec();
      var token = getToken.objRespuesta.token;
      const dataInfoCP = await this.getInformationCP(token, this.codigoPostalConyuge);
      if (!dataInfoCP) {
        this.coloniaConyuge = '';
        this.municipioConyuge = '';
        this.ColoniasCPConyuge = [];
        return;
      }
      const colonias = dataInfoCP.map(function (x) { return x.colonia; });
      this.ColoniasCPConyuge = colonias;
      this.municipioConyuge = dataInfoCP[0].municipio;
      if (origen == 0) {
        var matchedCyg = this.buscarColoniaEnLista(this.coloniaConyuge, colonias);
        if (matchedCyg) {
          this.coloniaConyuge = matchedCyg;
        } else if (this.coloniaConyuge && String(this.coloniaConyuge).trim() !== '') {
          this.ColoniasCPConyuge = [this.coloniaConyuge].concat(colonias);
        }
      }
    },
		async getTokenSisec() {
			const URL_Method = 'https://preprodcotizador.socasesores.com/consultaSisec/getTokenSisec.php'

			const { data, status } = await this.$axios
						.post(URL_Method,{headers : {'Content-Type':'application/json; charset=UTF-8'}})

			if ( status !== 200 ) {

				this.$vs.notify({
				title: 'Ocurrio un error en getTokenSisec',
				text: data.strError,
				color: 'danger',
				position: 'top-right',
				})

				return false

			}

			if ( data.intRespuesta ) {

				this.$vs.notify({
				title: 'Ocurrio un error en Metodo getTokenSisec',
				text: data.strError,
				color: 'danger',
				position: 'top-right',
				})

				return false

			}

			if ( !data.objRespuesta.status ) {

				this.$vs.notify({
				title: 'Ocurrio un error en API getTokenSisec',
				text: data.strError,
				color: 'danger',
				position: 'top-right',
				})

				return false

			}

			//console.log(data)
			return data;

		},
		async getInformationCP(token, codigoPostalParam) {
				var cp = codigoPostalParam;
				if (cp === undefined || cp === null) {
					cp = this.codigoPostal;
				}
				const jsonCP = {
									token,
									CodigoPostal: cp
								}

				const URL_Method = 'https://preprodcotizador.socasesores.com/consultaSisec/getInfoCP.php'

				const { status, data } = await this.$axios
						.post(URL_Method,jsonCP,{headers : {'Content-Type':'application/json; charset=UTF-8'}})

				if ( status !== 200 ) {

					this.$vs.notify({
						title: 'Ocurrio un error en getInformationCP',
						text: data.strError,
						color: 'danger',
						position: 'top-right',
					})

					return false

				}

				if ( data.intRespuesta ) {

					this.$vs.notify({
						title: 'Ocurrio un error en Metodo getInformationCP',
						text: data.strError,
						color: 'danger',
						position: 'top-right',
					})

					return false

				}

				if ( data.objRespuesta.message ) {

          this.$vs.notify({
          title: data.objRespuesta.message,
          text: data.strError,
          color: 'danger',
          position: 'top-right',
          })

          return false

        }

        if ( !data.objRespuesta.length ) {
          return false
        }

				return data.objRespuesta

		}
    
  }
}
</script>

<style lang="css" scoped>
.v-select{
    width: 100%;
}
.label-select{
  margin-top: 3%;
}

.content-radio {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
